import { iterate, toArray, empty as empty_1, singleton, append, delay, toList } from "../../client/src/fable_modules/fable-library.3.7.17/Seq.js";
import { createElement } from "react";
import * as react from "react";
import { NumberFieldFloat, DiscountOption__get_Label, NumberFieldDecimal, FileField, TextField, TextFieldDisabled, OptionField, DiscountOption, CheckBox, CheckIcon, DisplayData, Info, InfoTitle } from "../DesignSystem.fs.js";
import { Col, Row } from "../../Components/UtilComponents.fs.js";
import { alignEnd, Padding, modal, MarginLeft, Boldness, MarginRight, error, PaddingLeft, MarginTop, MarginBottom, flexExpand, Gap } from "../../Styles/Utils.fs.js";
import { length, item, map as map_1, toArray as toArray_1, filter, ofArray, empty, singleton as singleton_1 } from "../../client/src/fable_modules/fable-library.3.7.17/List.js";
import { MuiHelpers_createElement } from "../../client/src/fable_modules/Feliz.MaterialUI.1.2.6/./Mui.fs.js";
import Paper from "@material-ui/core/Paper";
import { Feliz_prop__prop_fss_Static_72C268A9 } from "../../client/src/fable_modules/Fss-lib.Feliz.1.0.3/FssFeliz.fs.js";
import { FlexClasses_FlexShrinkGrow__value_5E38073B } from "../../client/src/fable_modules/Fss-lib.Core.1.0.4/Types/Flex.fs.js";
import { FlexGrow } from "../../client/src/fable_modules/Fss-lib.Core.1.0.4/css/Flex.fs.js";
import Divider from "@material-ui/core/Divider";
import { CustomerCompanyData, CustomerData2, CustomerPersonData, DossierCustomerSelection, DossierCustomer, CreateQuoteDataContact, InvoicePricing, CreateQuoteData2, Customer2__get_Code, Customer2__get_CustomerOrCompanyName, VatNumber___UnsafeUnwrap_18C04ACB, AssignmentDocument, PhoneNumber_get_Create, CommentSource as CommentSource_1, CreateQuoteData, TypeOfDiscount, PartnerId, DossierStatus, DossierOwner__get_Address, InspectionLocationExtra, CommentType, TypeOfDossierData___UnsafeCreate_Z1D754B91, NonEmptyString, DossierOwner as DossierOwner_4, Compensation as Compensation_3, Decimal___UnsafeCreate_32C73145, Decimal_get_Create, Compensation_get_DefaultCompensation, DossierClient, InspectionLocation as InspectionLocation_1, AsbestInventoryData_Create_7B10C0C6, TypeOfDossierData_Create_Z6219B46, TypeOfDossier as TypeOfDossier_1, AsbestInventory, EmptyString_get_Create, NonEmptyString_get_Create, SelectOptionData$1_Create_Z510A3DC0, OwnerStatus as OwnerStatus_2, InvoicePricingModule_string, HomeVisitContactModule_string, CustomerData2__get_Address, CustomerData2__get_PhoneNumber, CustomerData2__get_Email, Customer2__get_Address, Customer2__get_PhoneNumber, PhoneNumber___UnsafeUnwrap_23E45174, Customer2__get_Email, Email___UnsafeUnwrap_Z27D11339, NonEmptyString___UnsafeUnwrap_Z73AD07C } from "../../shared/Domain.fs.js";
import { toArray as toArray_2, some, map, defaultArg } from "../../client/src/fable_modules/fable-library.3.7.17/Option.js";
import { InspectionLocation_extra, Compensation_compensation, InspectionLocation_type$0027, Address_address } from "../../shared/Format.fs.js";
import { Interop_reactApi } from "../../client/src/fable_modules/Feliz.1.68.0/./Interop.fs.js";
import { isNullOrEmpty, join, format } from "../../client/src/fable_modules/fable-library.3.7.17/String.js";
import List from "@material-ui/core/List";
import { useUsername, useToggle } from "../../CustomHooks/CustomHooks.fs.js";
import { useSnackbar } from "notistack";
import { singleton as singleton_2 } from "../../client/src/fable_modules/fable-library.3.7.17/AsyncBuilder.js";
import { EnqueueSnackbarOption, SnackbarProp_Variant_Z609E1E86, ProviderContext__enqueueSnackbar_Z1776A768 } from "../../Notistack/Notistack.fs.js";
import { compare, createObj, equals } from "../../client/src/fable_modules/fable-library.3.7.17/Util.js";
import { ImageList, DocumentsList, UploadDocumentModal } from "../QuoteFiles.fs.js";
import Button from "@material-ui/core/Button";
import CloudUpload from "@material-ui/icons/CloudUpload";
import { startImmediate } from "../../client/src/fable_modules/fable-library.3.7.17/Async.js";
import { useForm, useFormValidator, useFormField } from "../../CustomHooks/ComposedForm.fs.js";
import { ofSeq } from "../../client/src/fable_modules/fable-library.3.7.17/Set.js";
import { Compensation_fromDomain, AsbestInventoryProfile_get_defaultInventory, AsbestInventoryProfile } from "../../shared/DomainHelpers.fs.js";
import { ParseNonNegative } from "../../shared/Validators.fs.js";
import { CreateAddressFormWithReset, useAddressForm } from "../AddressHook.fs.js";
import { useReact_useElementRef, useReact_useButtonRef, useReact_useEffect_Z101E1A95, useFeliz_React__React_useState_Static_1505 } from "../../client/src/fable_modules/Feliz.1.68.0/React.fs.js";
import { ChooseCertificateContact, ChooseInvoicing, ChooseContactQuote, FindCustomer, CustomerOption, Invoiced, useCreateCustomerCompanyForm, useCreateCustomerPersonForm, CustomerOption_get_none, ChooseOwner, useCreateDossierOwnerPersonForm, useCreateDossierOwnerCompanyForm } from "../Contacts.fs.js";
import { compare as compare_1, fromParts } from "../../client/src/fable_modules/fable-library.3.7.17/Decimal.js";
import { getPartnerType, filterPartnerOptions, PartnerOption, PartnerOption_get_empty, PartnerOption_get_none } from "../partner/PartnerUtils.fs.js";
import RadioGroup from "@material-ui/core/RadioGroup";
import { QuoteStep, quoteStepString, quoteSteps, CompensationOptions, CompensationOptionsRestricted, DossierCreatePageSource, AsbestInventoryDataOptions } from "../DossierUtils.fs.js";
import { InspectionLocationType, ChooseInspectionLocationFormCheckbox } from "../InspectionLocation.fs.js";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Switch from "@material-ui/core/Switch";
import { Browser_Types_Event__Event_get_Checked } from "../../client/src/fable_modules/Feliz.MaterialUI.1.2.6/../Fable.React.7.4.0/Fable.React.Extensions.fs.js";
import FormControl from "@material-ui/core/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField_1 from "@material-ui/core/TextField";
import Chip from "@material-ui/core/Chip";
import Grid from "@material-ui/core/Grid";
import { SafeNotNullCheck } from "../Utils.fs.js";
import { RouterModule_nav } from "../../client/src/fable_modules/Feliz.Router.3.10.0/./Router.fs.js";
import { CommentData } from "../../shared/Api.fs.js";
import { mapIndexed } from "../../client/src/fable_modules/fable-library.3.7.17/Array.js";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Modal from "@material-ui/core/Modal";
import { CreateCustomerForm } from "../CustomerForms.fs.js";
import { DisplayDeferred } from "../DisplayDeferred.fs.js";

export function Review(reviewInputProps) {
    const isPartnerSelected = reviewInputProps.isPartnerSelected;
    const partnerName = reviewInputProps.partnerName;
    const quoteDataContact = reviewInputProps.quoteDataContact;
    const quoteData = reviewInputProps.quoteData;
    const children = toList(delay(() => append(singleton(createElement(InfoTitle, {
        text: "Factuur",
    })), delay(() => append(singleton(createElement(Info, {
        secondary: "Verantwoordelijkheid",
        primary: "Klant wordt direct gefactureerd",
    })), delay(() => singleton(createElement(Row, {
        classes: singleton_1(Gap.L),
        children: toList(delay(() => {
            let elems;
            return append(singleton(MuiHelpers_createElement(Paper, [Feliz_prop__prop_fss_Static_72C268A9(singleton_1(FlexClasses_FlexShrinkGrow__value_5E38073B(FlexGrow, 2))), (elems = [createElement(Col, {
                classes: empty(),
                children: ofArray([createElement(InfoTitle, {
                    text: "VME",
                }), MuiHelpers_createElement(Divider, []), createElement(DisplayData, {
                    data: toList(delay(() => {
                        let matchValue_4, person_2, company_2, matchValue_3, person_1, company_1, matchValue_1, person, company;
                        const matchValue = quoteDataContact.InvoicingParty;
                        switch (matchValue.tag) {
                            case 1: {
                                const matchValue_2 = matchValue.fields[0];
                                if (matchValue_2.tag === 0) {
                                    const customer_3 = matchValue_2.fields[0];
                                    return append((matchValue_4 = customer_3, (matchValue_4.tag === 0) ? ((person_2 = matchValue_4.fields[0], append(singleton(["Voornaam", NonEmptyString___UnsafeUnwrap_Z73AD07C(person_2.FirstName)]), delay(() => singleton(["Naam", NonEmptyString___UnsafeUnwrap_Z73AD07C(person_2.LastName)]))))) : ((company_2 = matchValue_4.fields[0], append(singleton(["Bedrijfsnaam", NonEmptyString___UnsafeUnwrap_Z73AD07C(company_2.CompanyName)]), delay(() => singleton(["Bedrijfstype", defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, company_2.CompanyType), "-")])))))), delay(() => append(singleton(["Emailadres", Email___UnsafeUnwrap_Z27D11339(Customer2__get_Email(customer_3))]), delay(() => append(singleton(["Telefoon", defaultArg(map(PhoneNumber___UnsafeUnwrap_23E45174, Customer2__get_PhoneNumber(customer_3)), "-")]), delay(() => singleton(["Adres", Address_address(Customer2__get_Address(customer_3))])))))));
                                }
                                else {
                                    const customer_2 = matchValue_2.fields[0];
                                    return append((matchValue_3 = customer_2, (matchValue_3.tag === 0) ? ((person_1 = matchValue_3.fields[0], append(singleton(["Voornaam", NonEmptyString___UnsafeUnwrap_Z73AD07C(person_1.FirstName)]), delay(() => singleton(["Naam", NonEmptyString___UnsafeUnwrap_Z73AD07C(person_1.LastName)]))))) : ((company_1 = matchValue_3.fields[0], append(singleton(["Bedrijfsnaam", NonEmptyString___UnsafeUnwrap_Z73AD07C(company_1.CompanyName)]), delay(() => singleton(["Bedrijfstype", defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, company_1.CompanyType), "-")])))))), delay(() => append(singleton(["Emailadres", Email___UnsafeUnwrap_Z27D11339(CustomerData2__get_Email(customer_2))]), delay(() => append(singleton(["Telefoon", defaultArg(map(PhoneNumber___UnsafeUnwrap_23E45174, CustomerData2__get_PhoneNumber(customer_2)), "-")]), delay(() => singleton(["Adres", Address_address(CustomerData2__get_Address(customer_2))])))))));
                                }
                            }
                            case 2: {
                                return empty_1();
                            }
                            default: {
                                const customer = matchValue.fields[0];
                                return append((matchValue_1 = customer, (matchValue_1.tag === 0) ? ((person = matchValue_1.fields[0], append(singleton(["Voornaam", NonEmptyString___UnsafeUnwrap_Z73AD07C(person.FirstName)]), delay(() => singleton(["Naam", NonEmptyString___UnsafeUnwrap_Z73AD07C(person.LastName)]))))) : ((company = matchValue_1.fields[0], append(singleton(["Bedrijfsnaam", NonEmptyString___UnsafeUnwrap_Z73AD07C(company.CompanyName)]), delay(() => singleton(["Bedrijfstype", defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, company.CompanyType), "-")])))))), delay(() => append(singleton(["Emailadres", Email___UnsafeUnwrap_Z27D11339(Customer2__get_Email(customer))]), delay(() => append(singleton(["Telefoon", defaultArg(map(PhoneNumber___UnsafeUnwrap_23E45174, Customer2__get_PhoneNumber(customer)), "-")]), delay(() => singleton(["Adres", Address_address(Customer2__get_Address(customer))])))))));
                            }
                        }
                    })),
                })]),
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])), delay(() => {
                let elems_1;
                return append(singleton(MuiHelpers_createElement(Paper, [Feliz_prop__prop_fss_Static_72C268A9(singleton_1(FlexClasses_FlexShrinkGrow__value_5E38073B(FlexGrow, 2))), (elems_1 = [createElement(Col, {
                    classes: empty(),
                    children: ofArray([createElement(InfoTitle, {
                        text: "Eigenaar",
                    }), MuiHelpers_createElement(Divider, []), createElement(DisplayData, {
                        data: toList(delay(() => {
                            const matchValue_5 = quoteData.DossierOwner;
                            if (matchValue_5.tag === 0) {
                                const person_3 = matchValue_5.fields[0];
                                return append(singleton(["Voornaam", NonEmptyString___UnsafeUnwrap_Z73AD07C(person_3.FirstName)]), delay(() => append(singleton(["Naam", NonEmptyString___UnsafeUnwrap_Z73AD07C(person_3.LastName)]), delay(() => append(singleton(["Emailadres", Email___UnsafeUnwrap_Z27D11339(person_3.Email)]), delay(() => append(singleton(["Telefoon", defaultArg(map(PhoneNumber___UnsafeUnwrap_23E45174, person_3.PhoneNumber), "-")]), delay(() => singleton(["Adres", Address_address(person_3.Address)])))))))));
                            }
                            else {
                                const company_3 = matchValue_5.fields[0];
                                return append(singleton(["Bedrijfsnaam", NonEmptyString___UnsafeUnwrap_Z73AD07C(company_3.CompanyName)]), delay(() => append(singleton(["Bedrijfstype", defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, company_3.CompanyType), "-")]), delay(() => {
                                    const patternInput = company_3.IsVME ? ["Beheerder Voornaam", "Beheerder Naam"] : ["Voornaam", "Naam"];
                                    return append(singleton([patternInput[0], defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, company_3.FirstName), "")]), delay(() => append(singleton([patternInput[1], defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, company_3.LastName), "")]), delay(() => append(singleton(["Emailadres", Email___UnsafeUnwrap_Z27D11339(company_3.Email)]), delay(() => append(singleton(["Telefoon", defaultArg(map(PhoneNumber___UnsafeUnwrap_23E45174, company_3.PhoneNumber), "-")]), delay(() => singleton(["Adres", Address_address(company_3.Address)])))))))));
                                }))));
                            }
                        })),
                    })]),
                })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])), delay(() => {
                    let elems_2;
                    return append(singleton(MuiHelpers_createElement(Paper, [Feliz_prop__prop_fss_Static_72C268A9(singleton_1(FlexClasses_FlexShrinkGrow__value_5E38073B(FlexGrow, 3))), (elems_2 = [createElement(Col, {
                        classes: empty(),
                        children: ofArray([createElement(InfoTitle, {
                            text: "Inspectielocatie",
                        }), MuiHelpers_createElement(Divider, []), createElement(Row, {
                            classes: empty(),
                            children: ofArray([createElement(Col, {
                                classes: singleton_1(flexExpand),
                                children: singleton_1(createElement(DisplayData, {
                                    data: ofArray([["Type", InspectionLocation_type$0027(quoteData.InspectionLocation.Value)], ["Straat", NonEmptyString___UnsafeUnwrap_Z73AD07C(quoteData.Address.Street)], ["Nummer", NonEmptyString___UnsafeUnwrap_Z73AD07C(quoteData.Address.Number)], ["Bus", defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, quoteData.Address.Bus), "--")], ["Postcode", NonEmptyString___UnsafeUnwrap_Z73AD07C(quoteData.Address.PostalCode)], ["Gemeente", NonEmptyString___UnsafeUnwrap_Z73AD07C(quoteData.Address.City)]]),
                                })),
                            }), createElement(Col, {
                                classes: singleton_1(flexExpand),
                                children: singleton_1(createElement(DisplayData, {
                                    data: toList(delay(() => {
                                        let matchValue_6;
                                        return append(singleton(["Gebouwdeel/Vleugel/Blok", (matchValue_6 = quoteData.BuildingDetail, (matchValue_6 == null) ? "-" : NonEmptyString___UnsafeUnwrap_Z73AD07C(matchValue_6))]), delay(() => {
                                            let matchValue_7;
                                            return append(singleton(["Wooneenheden", (matchValue_7 = quoteData.HousingUnit, (matchValue_7 == null) ? "-" : NonEmptyString___UnsafeUnwrap_Z73AD07C(matchValue_7))]), delay(() => {
                                                let matchValue_8;
                                                return append(singleton(["Jaar van constructie", (matchValue_8 = quoteData.YearsOfConstruction, (matchValue_8 == null) ? "-" : NonEmptyString___UnsafeUnwrap_Z73AD07C(matchValue_8))]), delay(() => {
                                                    let matchValue_9;
                                                    return append(singleton(["Jaar van renovatie", (matchValue_9 = quoteData.YearsOfRenovation, (matchValue_9 == null) ? "-" : NonEmptyString___UnsafeUnwrap_Z73AD07C(matchValue_9))]), delay(() => {
                                                        let matchValue_10;
                                                        return append(singleton(["Aantal ingangen in het gebouw", (matchValue_10 = quoteData.NumberOfEntrances, (matchValue_10 == null) ? "-" : NonEmptyString___UnsafeUnwrap_Z73AD07C(matchValue_10))]), delay(() => {
                                                            let matchValue_11;
                                                            return append(singleton(["Leidingisolatie (lopende meter)", (matchValue_11 = quoteData.PipeIsolationMeters, (matchValue_11 == null) ? "-" : NonEmptyString___UnsafeUnwrap_Z73AD07C(matchValue_11))]), delay(() => {
                                                                let matchValue_12;
                                                                return append(singleton(["Gangen per verdiep", (matchValue_12 = quoteData.HallwaysPerLevel, (matchValue_12 == null) ? "-" : NonEmptyString___UnsafeUnwrap_Z73AD07C(matchValue_12))]), delay(() => {
                                                                    let matchValue_14;
                                                                    return append((quoteData.InspectionLocation.Value.tag === 22) ? append(singleton(["Tellerlokalen", (matchValue_14 = quoteData.SharedAreaOption1, (matchValue_14 == null) ? "-" : NonEmptyString___UnsafeUnwrap_Z73AD07C(matchValue_14))]), delay(() => {
                                                                        let matchValue_15;
                                                                        return append(singleton(["Vuilnislokaal", (matchValue_15 = quoteData.SharedAreaOption2, (matchValue_15 == null) ? "-" : NonEmptyString___UnsafeUnwrap_Z73AD07C(matchValue_15))]), delay(() => {
                                                                            let matchValue_16;
                                                                            return append(singleton(["Fietsberging", (matchValue_16 = quoteData.SharedAreaOption3, (matchValue_16 == null) ? "-" : NonEmptyString___UnsafeUnwrap_Z73AD07C(matchValue_16))]), delay(() => {
                                                                                let matchValue_17;
                                                                                return singleton(["Gemene Delen Option 4", (matchValue_17 = quoteData.SharedAreaOption4, (matchValue_17 == null) ? "-" : NonEmptyString___UnsafeUnwrap_Z73AD07C(matchValue_17))]);
                                                                            }));
                                                                        }));
                                                                    })) : ((empty_1())), delay(() => singleton(["Stooklokaal", createElement(CheckIcon, {
                                                                        props: [],
                                                                        value: quoteData.BoilerRoom,
                                                                    })])));
                                                                }));
                                                            }));
                                                        }));
                                                    }));
                                                }));
                                            }));
                                        }));
                                    })),
                                })),
                            })]),
                        })]),
                    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])), delay(() => {
                        let elems_3;
                        return append(singleton(MuiHelpers_createElement(Paper, [Feliz_prop__prop_fss_Static_72C268A9(singleton_1(FlexClasses_FlexShrinkGrow__value_5E38073B(FlexGrow, 3))), (elems_3 = [createElement(Col, {
                            classes: empty(),
                            children: ofArray([createElement(InfoTitle, {
                                text: "Communicatie en facturatie",
                            }), MuiHelpers_createElement(Divider, []), createElement(Row, {
                                classes: empty(),
                                children: singleton_1(createElement(Col, {
                                    classes: singleton_1(flexExpand),
                                    children: ofArray([createElement(DisplayData, {
                                        data: singleton_1(["Contact afspraak", defaultArg(map(HomeVisitContactModule_string, quoteDataContact.HomeVisitContact), "")]),
                                    }), MuiHelpers_createElement(Divider, []), createElement(InfoTitle, {
                                        text: "We versturen het asbestattest naar",
                                    }), createElement(DisplayData, {
                                        data: toList(delay(() => append(singleton([partnerName, CheckBox(quoteDataContact.CertificateEmailPartner)]), delay(() => append(singleton(["Klant", CheckBox(quoteDataContact.CertificateEmailClient)]), delay(() => {
                                            const matchValue_18 = quoteDataContact.CertificateCustomEmails;
                                            if (matchValue_18 != null) {
                                                return singleton(["Extra Emails", matchValue_18.Value]);
                                            }
                                            else {
                                                return empty_1();
                                            }
                                        })))))),
                                    }), createElement(DisplayData, {
                                        data: singleton_1(["Tarieven van prijzen", InvoicePricingModule_string(quoteDataContact.InvoicePricing)]),
                                    })]),
                                })),
                            })]),
                        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])), delay(() => {
                            let elems_4;
                            if (isPartnerSelected) {
                                const matchValue_19 = quoteData.CompensationAmount;
                                if (matchValue_19 == null) {
                                    return singleton(null);
                                }
                                else {
                                    const p = matchValue_19;
                                    return singleton(MuiHelpers_createElement(Paper, [Feliz_prop__prop_fss_Static_72C268A9(singleton_1(FlexClasses_FlexShrinkGrow__value_5E38073B(FlexGrow, 3))), (elems_4 = [createElement(Col, {
                                        classes: empty(),
                                        children: ofArray([createElement(InfoTitle, {
                                            text: partnerName,
                                        }), MuiHelpers_createElement(Divider, []), createElement(Row, {
                                            classes: empty(),
                                            children: singleton_1(createElement(Col, {
                                                classes: singleton_1(flexExpand),
                                                children: singleton_1(createElement(DisplayData, {
                                                    data: singleton_1(["Vergoedingen", defaultArg(map(Compensation_compensation, quoteData.CompensationAmount), "-")]),
                                                })),
                                            })),
                                        }), createElement(Row, {
                                            classes: empty(),
                                            children: singleton_1(createElement(Col, {
                                                classes: singleton_1(flexExpand),
                                                children: singleton_1(createElement(DisplayData, {
                                                    data: singleton_1(["Prijs Offerte", "€ " + defaultArg(map((n) => format('{0:' + "0.00" + '}', n.Value), quoteData.CustomPrice), "")]),
                                                })),
                                            })),
                                        })]),
                                    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])]));
                                }
                            }
                            else {
                                return singleton(null);
                            }
                        }));
                    }));
                }));
            }));
        })),
    }))))))));
    return MuiHelpers_createElement(List, [["children", Interop_reactApi.Children.toArray(Array.from(children))]]);
}

export function UploadDocumentsStep(uploadDocumentsStepInputProps) {
    let elems, props, props_2;
    const getImage = uploadDocumentsStepInputProps.getImage;
    const setFiles = uploadDocumentsStepInputProps.setFiles;
    const files = uploadDocumentsStepInputProps.files;
    const api = uploadDocumentsStepInputProps.api;
    const showUploadDocumentModal = useToggle(false);
    const snackbar = useSnackbar();
    const deleteFile = (filePath) => singleton_2.Delay(() => singleton_2.TryWith(singleton_2.Delay(() => singleton_2.Bind(api.RemoveQuoteDocument(filePath), (_arg) => {
        if (_arg.tag === 1) {
            console.error(_arg.fields[0]);
            ProviderContext__enqueueSnackbar_Z1776A768(snackbar, "Een onbekende fout is opgetreden. Gelieve support te contacteren.", SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
            return singleton_2.Zero();
        }
        else {
            setFiles(filter((x) => (!equals(x.DocumentFilePath, filePath)), files));
            ProviderContext__enqueueSnackbar_Z1776A768(snackbar, "Verwijderd bestand", SnackbarProp_Variant_Z609E1E86("success"), new EnqueueSnackbarOption(1, false));
            return singleton_2.Zero();
        }
    })), (_arg_1) => {
        ProviderContext__enqueueSnackbar_Z1776A768(snackbar, "Een onbekende fout is opgetreden. Gelieve support te contacteren.", SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
        console.error(_arg_1);
        return singleton_2.Zero();
    }));
    return createElement("div", createObj(singleton_1((elems = [createElement(UploadDocumentModal, {
        api: api,
        showUploadDocumentModal: showUploadDocumentModal,
        filesList: files,
        setFilesList: setFiles,
    }), MuiHelpers_createElement(Button, [["onClick", (e_1) => {
        e_1.stopPropagation();
        e_1.preventDefault();
        showUploadDocumentModal.On();
    }], ["variant", "contained"], ["color", "default"], ["size", "small"], ["className", join(" ", [MarginBottom.M])], ["startIcon", (props = {}, react.createElement(CloudUpload, props))], ["children", "Document toevoegen"]]), createElement(DocumentsList, {
        quoteDocuments: files,
        getFile: api.GetDocument,
        deleteFile: (filepath) => {
            startImmediate(deleteFile(filepath));
        },
    }), MuiHelpers_createElement(Button, [["onClick", (e_2) => {
        e_2.stopPropagation();
        e_2.preventDefault();
        showUploadDocumentModal.On();
    }], ["variant", "contained"], ["color", "default"], ["size", "small"], ["className", join(" ", [MarginBottom.M, MarginTop.M])], ["startIcon", (props_2 = {}, react.createElement(CloudUpload, props_2))], ["children", "Afbeelding toevoegen"]]), createElement(ImageList, {
        quoteDocuments: files,
        getFile: api.GetDocument,
        getImage: getImage,
        deleteFile: (filepath_1) => {
            startImmediate(deleteFile(filepath_1));
        },
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))]))));
}

export function CreateQuoteForm(createQuoteFormInputProps) {
    let f1, f1_1, f1_2, f1_3, f1_4, f1_5, f1_6, f1_7, f1_8, f1_9;
    const compensation = createQuoteFormInputProps.compensation;
    const dossierCreatePageSource = createQuoteFormInputProps.dossierCreatePageSource;
    const buttonRef = createQuoteFormInputProps.buttonRef;
    const isCibDossier = createQuoteFormInputProps.isCibDossier;
    const onCreateDossier = createQuoteFormInputProps.onCreateDossier;
    const partners = createQuoteFormInputProps.partners;
    const backUrl = createQuoteFormInputProps.backUrl;
    const customerUrl = createQuoteFormInputProps.customerUrl;
    const isPartner = (dossierCreatePageSource.tag === 2) ? true : (!(dossierCreatePageSource.tag === 0));
    const ownerStatusData = useFormField(new OwnerStatus_2(7), SelectOptionData$1_Create_Z510A3DC0);
    const ownerStatusOther = useFormField("", NonEmptyString_get_Create());
    const buildingDetail = useFormField("", EmptyString_get_Create());
    const dossierTypeData = useFormField(isPartner ? (new TypeOfDossier_1(0, new AsbestInventory(0))) : (void 0), TypeOfDossierData_Create_Z6219B46);
    const asbestInventoryData = useFormField(new AsbestInventory(7), AsbestInventoryData_Create_7B10C0C6);
    const profile = isPartner ? (new AsbestInventoryProfile(ofSeq([new AsbestInventory(0)], {
        Compare: compare,
    }))) : (new AsbestInventoryProfile(ofSeq(AsbestInventoryProfile_get_defaultInventory(), {
        Compare: compare,
    })));
    const inspectionLocationData = useFormField(new InspectionLocation_1(22), SelectOptionData$1_Create_Z510A3DC0);
    const residentialOther = useFormField("", NonEmptyString_get_Create());
    const nonResidentialOther = useFormField("", NonEmptyString_get_Create());
    const inSocialUseOther = useFormField("", NonEmptyString_get_Create());
    const publicOther = useFormField("", NonEmptyString_get_Create());
    const residentialBerging = useFormField("0", NonEmptyString_get_Create());
    const residentialGaragebox = useFormField("0", NonEmptyString_get_Create());
    const sharedAreaOption1 = useFormField("", (f1 = NonEmptyString_get_Create(), (arg_5) => some(f1(arg_5))));
    const sharedAreaOption2 = useFormField("", (f1_1 = NonEmptyString_get_Create(), (arg_7) => some(f1_1(arg_7))));
    const sharedAreaOption3 = useFormField("", (f1_2 = NonEmptyString_get_Create(), (arg_9) => some(f1_2(arg_9))));
    const sharedAreaOption4 = useFormField("", (f1_3 = NonEmptyString_get_Create(), (arg_11) => some(f1_3(arg_11))));
    const dossierClientData = useFormField(new DossierClient(0), SelectOptionData$1_Create_Z510A3DC0);
    const isUserOwnerOfArea = useFormField(true, SelectOptionData$1_Create_Z510A3DC0);
    const yearOfConstruction = useFormField("", (f1_4 = NonEmptyString_get_Create(), (arg_15) => some(f1_4(arg_15))));
    const yearOfRenovation = useFormField("", (f1_5 = NonEmptyString_get_Create(), (arg_17) => some(f1_5(arg_17))));
    const numberOfEntrances = useFormField("", (f1_6 = NonEmptyString_get_Create(), (arg_19) => some(f1_6(arg_19))));
    const boilerRoom = useToggle(false);
    const pipleIsolationMeters = useFormField("", (f1_7 = NonEmptyString_get_Create(), (arg_21) => some(f1_7(arg_21))));
    const hallwaysPerLevel = useFormField("", (f1_8 = NonEmptyString_get_Create(), (arg_23) => some(f1_8(arg_23))));
    const discount = useFormField("0", ParseNonNegative);
    const addressCase = useAddressForm("", "", "", "", "");
    const sendMailToPartner = useToggle(true);
    const manualInvoice = useToggle(false);
    const yearOfConstructionRequiredError = useFeliz_React__React_useState_Static_1505(false)[0];
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(false);
    const patternInput_2 = useFeliz_React__React_useState_Static_1505(isCibDossier);
    const ownerOption = useFormField(void 0, SelectOptionData$1_Create_Z510A3DC0);
    const ownerCompany = useCreateDossierOwnerCompanyForm("", "", "", "", "", "", "", "", "", "", false, false, "", "");
    const ownerPerson = useCreateDossierOwnerPersonForm("", "", "", "", "", "", "", "", "");
    const patternInput_3 = useFeliz_React__React_useState_Static_1505(void 0);
    const inspectionLocationBerging = useToggle(false);
    const inspectionLocationStaanplaats = useToggle(false);
    const inspectionLocationGaragebox = useToggle(false);
    const compensationData = useFormField(compensation, SelectOptionData$1_Create_Z510A3DC0);
    let compensationCustomAmt;
    const matchValue = compensationData.FieldValue;
    if (matchValue == null) {
        compensationCustomAmt = Compensation_fromDomain(Compensation_get_DefaultCompensation());
    }
    else {
        const c = matchValue;
        compensationCustomAmt = ((c.tag === 11) ? c.fields[0].Value : Compensation_fromDomain(Compensation_get_DefaultCompensation()));
    }
    const compensationCustom = useFormField(compensationCustomAmt, Decimal_get_Create());
    const customPrice = useFormField(fromParts(0, 0, 0, false, 0), (f1_9 = Decimal_get_Create(), (arg_27) => some(f1_9(arg_27))));
    const compensationCustom_1 = useFormField(compensationCustomAmt, Decimal_get_Create());
    const patternInput_4 = useFeliz_React__React_useState_Static_1505(false);
    const isSameAddress = patternInput_4[0];
    const patternInput_5 = useFeliz_React__React_useState_Static_1505(false);
    const setDisable = patternInput_5[1];
    const disable = patternInput_5[0];
    const patternInput_6 = useFeliz_React__React_useState_Static_1505((partners == null) ? PartnerOption_get_none() : PartnerOption_get_empty());
    const partnerOption = patternInput_6[0];
    const patternInput_7 = useFeliz_React__React_useState_Static_1505(false);
    const setSelectPartnerError = patternInput_7[1];
    const selectPartnerError = patternInput_7[0];
    useReact_useEffect_Z101E1A95(() => {
        const matchValue_1 = ownerOption.FieldValue;
        if (matchValue_1 != null) {
            if (matchValue_1.tag === 1) {
                if (ownerCompany.Social.State) {
                    ownerStatusData.SetFieldValue(new OwnerStatus_2(1));
                }
                else {
                    ownerStatusData.SetFieldValue(new OwnerStatus_2(6));
                }
            }
            else {
                ownerStatusData.SetFieldValue(new OwnerStatus_2(0));
            }
        }
    }, [ownerOption.FieldValue, ownerCompany.Social.State]);
    useReact_useEffect_Z101E1A95(() => {
        if (equals(partnerOption, PartnerOption_get_empty()) ? true : equals(partnerOption, PartnerOption_get_none())) {
        }
        else {
            let compensationAmt;
            const matchValue_2 = partnerOption.CompensationAmount;
            compensationAmt = ((matchValue_2 == null) ? Compensation_get_DefaultCompensation() : matchValue_2);
            let compensationCustomAmt_1;
            const matchValue_3 = partnerOption.CompensationAmount;
            if (matchValue_3 == null) {
                compensationCustomAmt_1 = Compensation_fromDomain(Compensation_get_DefaultCompensation());
            }
            else {
                const c_2 = matchValue_3;
                compensationCustomAmt_1 = ((c_2.tag === 11) ? c_2.fields[0].Value : Compensation_fromDomain(Compensation_get_DefaultCompensation()));
            }
            compensationData.SetFieldValue(compensationAmt);
            compensationCustom_1.SetFieldValue(compensationCustomAmt_1);
        }
    }, [partnerOption]);
    const validateOther = (r, otherFormField) => {
        const matchValue_4 = useFormValidator(otherFormField.Validator, (unitVar_2, y_2) => ({
            Other: y_2,
        }), useForm()).Validate();
        if (matchValue_4 == null) {
            return void 0;
        }
        else {
            return matchValue_4.Other;
        }
    };
    const form = useFormValidator(compensationData.Validator, (r_19, x_22) => {
        if (x_22.Value.tag === 11) {
            if (compare_1(compensationCustom_1.FieldValue, fromParts(0, 0, 0, false, 0)) > 0) {
                return {
                    Address: r_19.Address,
                    BuildingDetail: r_19.BuildingDetail,
                    Compensation: new Compensation_3(11, Decimal___UnsafeCreate_32C73145(compensationCustom_1.FieldValue)),
                    CustomPrice: r_19.CustomPrice,
                    Discount: r_19.Discount,
                    DossierClient: r_19.DossierClient,
                    DossierOwner: r_19.DossierOwner,
                    DossierType: r_19.DossierType,
                    HallwaysPerLevel: r_19.HallwaysPerLevel,
                    InspectionLocation: r_19.InspectionLocation,
                    InspectionLocationBerging: r_19.InspectionLocationBerging,
                    InspectionLocationGaragebox: r_19.InspectionLocationGaragebox,
                    InspectionLocationOther: r_19.InspectionLocationOther,
                    InspectionLocationStaanplaats: r_19.InspectionLocationStaanplaats,
                    IsUserOwnerOfArea: r_19.IsUserOwnerOfArea,
                    NumberOfEntrances: r_19.NumberOfEntrances,
                    OwnerStatus: r_19.OwnerStatus,
                    OwnerStatusOther: r_19.OwnerStatusOther,
                    PipeIsolationMeters: r_19.PipeIsolationMeters,
                    SharedAreaOption1: r_19.SharedAreaOption1,
                    SharedAreaOption2: r_19.SharedAreaOption2,
                    SharedAreaOption3: r_19.SharedAreaOption3,
                    SharedAreaOption4: r_19.SharedAreaOption4,
                    YearOfRenovation: r_19.YearOfRenovation,
                    YearsOfConstruction: r_19.YearsOfConstruction,
                };
            }
            else {
                return {
                    Address: r_19.Address,
                    BuildingDetail: r_19.BuildingDetail,
                    Compensation: void 0,
                    CustomPrice: r_19.CustomPrice,
                    Discount: r_19.Discount,
                    DossierClient: r_19.DossierClient,
                    DossierOwner: r_19.DossierOwner,
                    DossierType: r_19.DossierType,
                    HallwaysPerLevel: r_19.HallwaysPerLevel,
                    InspectionLocation: r_19.InspectionLocation,
                    InspectionLocationBerging: r_19.InspectionLocationBerging,
                    InspectionLocationGaragebox: r_19.InspectionLocationGaragebox,
                    InspectionLocationOther: r_19.InspectionLocationOther,
                    InspectionLocationStaanplaats: r_19.InspectionLocationStaanplaats,
                    IsUserOwnerOfArea: r_19.IsUserOwnerOfArea,
                    NumberOfEntrances: r_19.NumberOfEntrances,
                    OwnerStatus: r_19.OwnerStatus,
                    OwnerStatusOther: r_19.OwnerStatusOther,
                    PipeIsolationMeters: r_19.PipeIsolationMeters,
                    SharedAreaOption1: r_19.SharedAreaOption1,
                    SharedAreaOption2: r_19.SharedAreaOption2,
                    SharedAreaOption3: r_19.SharedAreaOption3,
                    SharedAreaOption4: r_19.SharedAreaOption4,
                    YearOfRenovation: r_19.YearOfRenovation,
                    YearsOfConstruction: r_19.YearsOfConstruction,
                };
            }
        }
        else {
            return {
                Address: r_19.Address,
                BuildingDetail: r_19.BuildingDetail,
                Compensation: x_22.Value,
                CustomPrice: r_19.CustomPrice,
                Discount: r_19.Discount,
                DossierClient: r_19.DossierClient,
                DossierOwner: r_19.DossierOwner,
                DossierType: r_19.DossierType,
                HallwaysPerLevel: r_19.HallwaysPerLevel,
                InspectionLocation: r_19.InspectionLocation,
                InspectionLocationBerging: r_19.InspectionLocationBerging,
                InspectionLocationGaragebox: r_19.InspectionLocationGaragebox,
                InspectionLocationOther: r_19.InspectionLocationOther,
                InspectionLocationStaanplaats: r_19.InspectionLocationStaanplaats,
                IsUserOwnerOfArea: r_19.IsUserOwnerOfArea,
                NumberOfEntrances: r_19.NumberOfEntrances,
                OwnerStatus: r_19.OwnerStatus,
                OwnerStatusOther: r_19.OwnerStatusOther,
                PipeIsolationMeters: r_19.PipeIsolationMeters,
                SharedAreaOption1: r_19.SharedAreaOption1,
                SharedAreaOption2: r_19.SharedAreaOption2,
                SharedAreaOption3: r_19.SharedAreaOption3,
                SharedAreaOption4: r_19.SharedAreaOption4,
                YearOfRenovation: r_19.YearOfRenovation,
                YearsOfConstruction: r_19.YearsOfConstruction,
            };
        }
    }, useFormValidator(ownerStatusData.Validator, (r_18, x_21) => {
        if (x_21.Value.tag === 8) {
            const matchValue_11 = useFormValidator(ownerStatusOther.Validator, (unitVar_7, y_5) => ({
                OwnerStatusOther: y_5,
            }), useForm()).Validate();
            if (matchValue_11 == null) {
                return {
                    Address: r_18.Address,
                    BuildingDetail: r_18.BuildingDetail,
                    CustomPrice: r_18.CustomPrice,
                    Discount: r_18.Discount,
                    DossierClient: r_18.DossierClient,
                    DossierOwner: r_18.DossierOwner,
                    DossierType: r_18.DossierType,
                    HallwaysPerLevel: r_18.HallwaysPerLevel,
                    InspectionLocation: r_18.InspectionLocation,
                    InspectionLocationBerging: r_18.InspectionLocationBerging,
                    InspectionLocationGaragebox: r_18.InspectionLocationGaragebox,
                    InspectionLocationOther: r_18.InspectionLocationOther,
                    InspectionLocationStaanplaats: r_18.InspectionLocationStaanplaats,
                    IsUserOwnerOfArea: r_18.IsUserOwnerOfArea,
                    NumberOfEntrances: r_18.NumberOfEntrances,
                    OwnerStatus: x_21,
                    OwnerStatusOther: void 0,
                    PipeIsolationMeters: r_18.PipeIsolationMeters,
                    SharedAreaOption1: r_18.SharedAreaOption1,
                    SharedAreaOption2: r_18.SharedAreaOption2,
                    SharedAreaOption3: r_18.SharedAreaOption3,
                    SharedAreaOption4: r_18.SharedAreaOption4,
                    YearOfRenovation: r_18.YearOfRenovation,
                    YearsOfConstruction: r_18.YearsOfConstruction,
                };
            }
            else {
                return {
                    Address: r_18.Address,
                    BuildingDetail: r_18.BuildingDetail,
                    CustomPrice: r_18.CustomPrice,
                    Discount: r_18.Discount,
                    DossierClient: r_18.DossierClient,
                    DossierOwner: r_18.DossierOwner,
                    DossierType: r_18.DossierType,
                    HallwaysPerLevel: r_18.HallwaysPerLevel,
                    InspectionLocation: r_18.InspectionLocation,
                    InspectionLocationBerging: r_18.InspectionLocationBerging,
                    InspectionLocationGaragebox: r_18.InspectionLocationGaragebox,
                    InspectionLocationOther: r_18.InspectionLocationOther,
                    InspectionLocationStaanplaats: r_18.InspectionLocationStaanplaats,
                    IsUserOwnerOfArea: r_18.IsUserOwnerOfArea,
                    NumberOfEntrances: r_18.NumberOfEntrances,
                    OwnerStatus: x_21,
                    OwnerStatusOther: matchValue_11.OwnerStatusOther,
                    PipeIsolationMeters: r_18.PipeIsolationMeters,
                    SharedAreaOption1: r_18.SharedAreaOption1,
                    SharedAreaOption2: r_18.SharedAreaOption2,
                    SharedAreaOption3: r_18.SharedAreaOption3,
                    SharedAreaOption4: r_18.SharedAreaOption4,
                    YearOfRenovation: r_18.YearOfRenovation,
                    YearsOfConstruction: r_18.YearsOfConstruction,
                };
            }
        }
        else {
            return {
                Address: r_18.Address,
                BuildingDetail: r_18.BuildingDetail,
                CustomPrice: r_18.CustomPrice,
                Discount: r_18.Discount,
                DossierClient: r_18.DossierClient,
                DossierOwner: r_18.DossierOwner,
                DossierType: r_18.DossierType,
                HallwaysPerLevel: r_18.HallwaysPerLevel,
                InspectionLocation: r_18.InspectionLocation,
                InspectionLocationBerging: r_18.InspectionLocationBerging,
                InspectionLocationGaragebox: r_18.InspectionLocationGaragebox,
                InspectionLocationOther: r_18.InspectionLocationOther,
                InspectionLocationStaanplaats: r_18.InspectionLocationStaanplaats,
                IsUserOwnerOfArea: r_18.IsUserOwnerOfArea,
                NumberOfEntrances: r_18.NumberOfEntrances,
                OwnerStatus: x_21,
                OwnerStatusOther: void 0,
                PipeIsolationMeters: r_18.PipeIsolationMeters,
                SharedAreaOption1: r_18.SharedAreaOption1,
                SharedAreaOption2: r_18.SharedAreaOption2,
                SharedAreaOption3: r_18.SharedAreaOption3,
                SharedAreaOption4: r_18.SharedAreaOption4,
                YearOfRenovation: r_18.YearOfRenovation,
                YearsOfConstruction: r_18.YearsOfConstruction,
            };
        }
    }, useFormValidator(ownerOption.Validator, (r_17, x_20) => {
        if (x_20.Value.tag === 0) {
            const matchValue_9 = useFormValidator(ownerPerson.Validator, (unitVar_6, y_4) => ({
                DossierOwner: new DossierOwner_4(0, y_4),
            }), useForm()).Validate();
            if (matchValue_9 == null) {
                return {
                    Address: r_17.Address,
                    BuildingDetail: r_17.BuildingDetail,
                    CustomPrice: r_17.CustomPrice,
                    Discount: r_17.Discount,
                    DossierClient: r_17.DossierClient,
                    DossierOwner: void 0,
                    DossierType: r_17.DossierType,
                    HallwaysPerLevel: r_17.HallwaysPerLevel,
                    InspectionLocation: r_17.InspectionLocation,
                    InspectionLocationBerging: r_17.InspectionLocationBerging,
                    InspectionLocationGaragebox: r_17.InspectionLocationGaragebox,
                    InspectionLocationOther: r_17.InspectionLocationOther,
                    InspectionLocationStaanplaats: r_17.InspectionLocationStaanplaats,
                    IsUserOwnerOfArea: r_17.IsUserOwnerOfArea,
                    NumberOfEntrances: r_17.NumberOfEntrances,
                    OwnerStatus: r_17.OwnerStatus,
                    PipeIsolationMeters: r_17.PipeIsolationMeters,
                    SharedAreaOption1: r_17.SharedAreaOption1,
                    SharedAreaOption2: r_17.SharedAreaOption2,
                    SharedAreaOption3: r_17.SharedAreaOption3,
                    SharedAreaOption4: r_17.SharedAreaOption4,
                    YearOfRenovation: r_17.YearOfRenovation,
                    YearsOfConstruction: r_17.YearsOfConstruction,
                };
            }
            else {
                return {
                    Address: r_17.Address,
                    BuildingDetail: r_17.BuildingDetail,
                    CustomPrice: r_17.CustomPrice,
                    Discount: r_17.Discount,
                    DossierClient: r_17.DossierClient,
                    DossierOwner: matchValue_9.DossierOwner,
                    DossierType: r_17.DossierType,
                    HallwaysPerLevel: r_17.HallwaysPerLevel,
                    InspectionLocation: r_17.InspectionLocation,
                    InspectionLocationBerging: r_17.InspectionLocationBerging,
                    InspectionLocationGaragebox: r_17.InspectionLocationGaragebox,
                    InspectionLocationOther: r_17.InspectionLocationOther,
                    InspectionLocationStaanplaats: r_17.InspectionLocationStaanplaats,
                    IsUserOwnerOfArea: r_17.IsUserOwnerOfArea,
                    NumberOfEntrances: r_17.NumberOfEntrances,
                    OwnerStatus: r_17.OwnerStatus,
                    PipeIsolationMeters: r_17.PipeIsolationMeters,
                    SharedAreaOption1: r_17.SharedAreaOption1,
                    SharedAreaOption2: r_17.SharedAreaOption2,
                    SharedAreaOption3: r_17.SharedAreaOption3,
                    SharedAreaOption4: r_17.SharedAreaOption4,
                    YearOfRenovation: r_17.YearOfRenovation,
                    YearsOfConstruction: r_17.YearsOfConstruction,
                };
            }
        }
        else {
            const matchValue_8 = useFormValidator(ownerCompany.Validator, (unitVar_5, y_3) => ({
                DossierOwner: new DossierOwner_4(1, y_3),
            }), useForm()).Validate();
            if (matchValue_8 == null) {
                return {
                    Address: r_17.Address,
                    BuildingDetail: r_17.BuildingDetail,
                    CustomPrice: r_17.CustomPrice,
                    Discount: r_17.Discount,
                    DossierClient: r_17.DossierClient,
                    DossierOwner: void 0,
                    DossierType: r_17.DossierType,
                    HallwaysPerLevel: r_17.HallwaysPerLevel,
                    InspectionLocation: r_17.InspectionLocation,
                    InspectionLocationBerging: r_17.InspectionLocationBerging,
                    InspectionLocationGaragebox: r_17.InspectionLocationGaragebox,
                    InspectionLocationOther: r_17.InspectionLocationOther,
                    InspectionLocationStaanplaats: r_17.InspectionLocationStaanplaats,
                    IsUserOwnerOfArea: r_17.IsUserOwnerOfArea,
                    NumberOfEntrances: r_17.NumberOfEntrances,
                    OwnerStatus: r_17.OwnerStatus,
                    PipeIsolationMeters: r_17.PipeIsolationMeters,
                    SharedAreaOption1: r_17.SharedAreaOption1,
                    SharedAreaOption2: r_17.SharedAreaOption2,
                    SharedAreaOption3: r_17.SharedAreaOption3,
                    SharedAreaOption4: r_17.SharedAreaOption4,
                    YearOfRenovation: r_17.YearOfRenovation,
                    YearsOfConstruction: r_17.YearsOfConstruction,
                };
            }
            else {
                return {
                    Address: r_17.Address,
                    BuildingDetail: r_17.BuildingDetail,
                    CustomPrice: r_17.CustomPrice,
                    Discount: r_17.Discount,
                    DossierClient: r_17.DossierClient,
                    DossierOwner: matchValue_8.DossierOwner,
                    DossierType: r_17.DossierType,
                    HallwaysPerLevel: r_17.HallwaysPerLevel,
                    InspectionLocation: r_17.InspectionLocation,
                    InspectionLocationBerging: r_17.InspectionLocationBerging,
                    InspectionLocationGaragebox: r_17.InspectionLocationGaragebox,
                    InspectionLocationOther: r_17.InspectionLocationOther,
                    InspectionLocationStaanplaats: r_17.InspectionLocationStaanplaats,
                    IsUserOwnerOfArea: r_17.IsUserOwnerOfArea,
                    NumberOfEntrances: r_17.NumberOfEntrances,
                    OwnerStatus: r_17.OwnerStatus,
                    PipeIsolationMeters: r_17.PipeIsolationMeters,
                    SharedAreaOption1: r_17.SharedAreaOption1,
                    SharedAreaOption2: r_17.SharedAreaOption2,
                    SharedAreaOption3: r_17.SharedAreaOption3,
                    SharedAreaOption4: r_17.SharedAreaOption4,
                    YearOfRenovation: r_17.YearOfRenovation,
                    YearsOfConstruction: r_17.YearsOfConstruction,
                };
            }
        }
    }, useFormValidator(sharedAreaOption4.Validator, (r_16, x_19) => ({
        Address: r_16.Address,
        BuildingDetail: r_16.BuildingDetail,
        CustomPrice: r_16.CustomPrice,
        Discount: r_16.Discount,
        DossierClient: r_16.DossierClient,
        DossierType: r_16.DossierType,
        HallwaysPerLevel: r_16.HallwaysPerLevel,
        InspectionLocation: r_16.InspectionLocation,
        InspectionLocationBerging: r_16.InspectionLocationBerging,
        InspectionLocationGaragebox: r_16.InspectionLocationGaragebox,
        InspectionLocationOther: r_16.InspectionLocationOther,
        InspectionLocationStaanplaats: r_16.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_16.IsUserOwnerOfArea,
        NumberOfEntrances: r_16.NumberOfEntrances,
        OwnerStatus: r_16.OwnerStatus,
        PipeIsolationMeters: r_16.PipeIsolationMeters,
        SharedAreaOption1: r_16.SharedAreaOption1,
        SharedAreaOption2: r_16.SharedAreaOption2,
        SharedAreaOption3: r_16.SharedAreaOption3,
        SharedAreaOption4: x_19,
        YearOfRenovation: r_16.YearOfRenovation,
        YearsOfConstruction: r_16.YearsOfConstruction,
    }), useFormValidator(sharedAreaOption3.Validator, (r_15, x_18) => ({
        Address: r_15.Address,
        BuildingDetail: r_15.BuildingDetail,
        CustomPrice: r_15.CustomPrice,
        Discount: r_15.Discount,
        DossierClient: r_15.DossierClient,
        DossierType: r_15.DossierType,
        HallwaysPerLevel: r_15.HallwaysPerLevel,
        InspectionLocation: r_15.InspectionLocation,
        InspectionLocationBerging: r_15.InspectionLocationBerging,
        InspectionLocationGaragebox: r_15.InspectionLocationGaragebox,
        InspectionLocationOther: r_15.InspectionLocationOther,
        InspectionLocationStaanplaats: r_15.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_15.IsUserOwnerOfArea,
        NumberOfEntrances: r_15.NumberOfEntrances,
        OwnerStatus: r_15.OwnerStatus,
        PipeIsolationMeters: r_15.PipeIsolationMeters,
        SharedAreaOption1: r_15.SharedAreaOption1,
        SharedAreaOption2: r_15.SharedAreaOption2,
        SharedAreaOption3: x_18,
        YearOfRenovation: r_15.YearOfRenovation,
        YearsOfConstruction: r_15.YearsOfConstruction,
    }), useFormValidator(sharedAreaOption2.Validator, (r_14, x_17) => ({
        Address: r_14.Address,
        BuildingDetail: r_14.BuildingDetail,
        CustomPrice: r_14.CustomPrice,
        Discount: r_14.Discount,
        DossierClient: r_14.DossierClient,
        DossierType: r_14.DossierType,
        HallwaysPerLevel: r_14.HallwaysPerLevel,
        InspectionLocation: r_14.InspectionLocation,
        InspectionLocationBerging: r_14.InspectionLocationBerging,
        InspectionLocationGaragebox: r_14.InspectionLocationGaragebox,
        InspectionLocationOther: r_14.InspectionLocationOther,
        InspectionLocationStaanplaats: r_14.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_14.IsUserOwnerOfArea,
        NumberOfEntrances: r_14.NumberOfEntrances,
        OwnerStatus: r_14.OwnerStatus,
        PipeIsolationMeters: r_14.PipeIsolationMeters,
        SharedAreaOption1: r_14.SharedAreaOption1,
        SharedAreaOption2: x_17,
        YearOfRenovation: r_14.YearOfRenovation,
        YearsOfConstruction: r_14.YearsOfConstruction,
    }), useFormValidator(sharedAreaOption1.Validator, (r_13, x_16) => ({
        Address: r_13.Address,
        BuildingDetail: r_13.BuildingDetail,
        CustomPrice: r_13.CustomPrice,
        Discount: r_13.Discount,
        DossierClient: r_13.DossierClient,
        DossierType: r_13.DossierType,
        HallwaysPerLevel: r_13.HallwaysPerLevel,
        InspectionLocation: r_13.InspectionLocation,
        InspectionLocationBerging: r_13.InspectionLocationBerging,
        InspectionLocationGaragebox: r_13.InspectionLocationGaragebox,
        InspectionLocationOther: r_13.InspectionLocationOther,
        InspectionLocationStaanplaats: r_13.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_13.IsUserOwnerOfArea,
        NumberOfEntrances: r_13.NumberOfEntrances,
        OwnerStatus: r_13.OwnerStatus,
        PipeIsolationMeters: r_13.PipeIsolationMeters,
        SharedAreaOption1: x_16,
        YearOfRenovation: r_13.YearOfRenovation,
        YearsOfConstruction: r_13.YearsOfConstruction,
    }), useFormValidator(customPrice.Validator, (r_12, x_15) => ({
        Address: r_12.Address,
        BuildingDetail: r_12.BuildingDetail,
        CustomPrice: x_15,
        Discount: r_12.Discount,
        DossierClient: r_12.DossierClient,
        DossierType: r_12.DossierType,
        HallwaysPerLevel: r_12.HallwaysPerLevel,
        InspectionLocation: r_12.InspectionLocation,
        InspectionLocationBerging: r_12.InspectionLocationBerging,
        InspectionLocationGaragebox: r_12.InspectionLocationGaragebox,
        InspectionLocationOther: r_12.InspectionLocationOther,
        InspectionLocationStaanplaats: r_12.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_12.IsUserOwnerOfArea,
        NumberOfEntrances: r_12.NumberOfEntrances,
        OwnerStatus: r_12.OwnerStatus,
        PipeIsolationMeters: r_12.PipeIsolationMeters,
        YearOfRenovation: r_12.YearOfRenovation,
        YearsOfConstruction: r_12.YearsOfConstruction,
    }), useFormValidator(discount.Validator, (r_11, x_14) => ({
        Address: r_11.Address,
        BuildingDetail: r_11.BuildingDetail,
        Discount: x_14,
        DossierClient: r_11.DossierClient,
        DossierType: r_11.DossierType,
        HallwaysPerLevel: r_11.HallwaysPerLevel,
        InspectionLocation: r_11.InspectionLocation,
        InspectionLocationBerging: r_11.InspectionLocationBerging,
        InspectionLocationGaragebox: r_11.InspectionLocationGaragebox,
        InspectionLocationOther: r_11.InspectionLocationOther,
        InspectionLocationStaanplaats: r_11.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_11.IsUserOwnerOfArea,
        NumberOfEntrances: r_11.NumberOfEntrances,
        OwnerStatus: r_11.OwnerStatus,
        PipeIsolationMeters: r_11.PipeIsolationMeters,
        YearOfRenovation: r_11.YearOfRenovation,
        YearsOfConstruction: r_11.YearsOfConstruction,
    }), useFormValidator(hallwaysPerLevel.Validator, (r_10, x_13) => ({
        Address: r_10.Address,
        BuildingDetail: r_10.BuildingDetail,
        DossierClient: r_10.DossierClient,
        DossierType: r_10.DossierType,
        HallwaysPerLevel: x_13,
        InspectionLocation: r_10.InspectionLocation,
        InspectionLocationBerging: r_10.InspectionLocationBerging,
        InspectionLocationGaragebox: r_10.InspectionLocationGaragebox,
        InspectionLocationOther: r_10.InspectionLocationOther,
        InspectionLocationStaanplaats: r_10.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_10.IsUserOwnerOfArea,
        NumberOfEntrances: r_10.NumberOfEntrances,
        OwnerStatus: r_10.OwnerStatus,
        PipeIsolationMeters: r_10.PipeIsolationMeters,
        YearOfRenovation: r_10.YearOfRenovation,
        YearsOfConstruction: r_10.YearsOfConstruction,
    }), useFormValidator(pipleIsolationMeters.Validator, (r_9, x_12) => ({
        Address: r_9.Address,
        BuildingDetail: r_9.BuildingDetail,
        DossierClient: r_9.DossierClient,
        DossierType: r_9.DossierType,
        InspectionLocation: r_9.InspectionLocation,
        InspectionLocationBerging: r_9.InspectionLocationBerging,
        InspectionLocationGaragebox: r_9.InspectionLocationGaragebox,
        InspectionLocationOther: r_9.InspectionLocationOther,
        InspectionLocationStaanplaats: r_9.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_9.IsUserOwnerOfArea,
        NumberOfEntrances: r_9.NumberOfEntrances,
        OwnerStatus: r_9.OwnerStatus,
        PipeIsolationMeters: x_12,
        YearOfRenovation: r_9.YearOfRenovation,
        YearsOfConstruction: r_9.YearsOfConstruction,
    }), useFormValidator(numberOfEntrances.Validator, (r_8, x_11) => ({
        Address: r_8.Address,
        BuildingDetail: r_8.BuildingDetail,
        DossierClient: r_8.DossierClient,
        DossierType: r_8.DossierType,
        InspectionLocation: r_8.InspectionLocation,
        InspectionLocationBerging: r_8.InspectionLocationBerging,
        InspectionLocationGaragebox: r_8.InspectionLocationGaragebox,
        InspectionLocationOther: r_8.InspectionLocationOther,
        InspectionLocationStaanplaats: r_8.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_8.IsUserOwnerOfArea,
        NumberOfEntrances: x_11,
        OwnerStatus: r_8.OwnerStatus,
        YearOfRenovation: r_8.YearOfRenovation,
        YearsOfConstruction: r_8.YearsOfConstruction,
    }), useFormValidator(yearOfRenovation.Validator, (r_7, x_10) => ({
        Address: r_7.Address,
        BuildingDetail: r_7.BuildingDetail,
        DossierClient: r_7.DossierClient,
        DossierType: r_7.DossierType,
        InspectionLocation: r_7.InspectionLocation,
        InspectionLocationBerging: r_7.InspectionLocationBerging,
        InspectionLocationGaragebox: r_7.InspectionLocationGaragebox,
        InspectionLocationOther: r_7.InspectionLocationOther,
        InspectionLocationStaanplaats: r_7.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_7.IsUserOwnerOfArea,
        OwnerStatus: r_7.OwnerStatus,
        YearOfRenovation: x_10,
        YearsOfConstruction: r_7.YearsOfConstruction,
    }), useFormValidator(yearOfConstruction.Validator, (r_6, x_9) => ({
        Address: r_6.Address,
        BuildingDetail: r_6.BuildingDetail,
        DossierClient: r_6.DossierClient,
        DossierType: r_6.DossierType,
        InspectionLocation: r_6.InspectionLocation,
        InspectionLocationBerging: r_6.InspectionLocationBerging,
        InspectionLocationGaragebox: r_6.InspectionLocationGaragebox,
        InspectionLocationOther: r_6.InspectionLocationOther,
        InspectionLocationStaanplaats: r_6.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: r_6.IsUserOwnerOfArea,
        OwnerStatus: r_6.OwnerStatus,
        YearsOfConstruction: x_9,
    }), useFormValidator(isUserOwnerOfArea.Validator, (r_5, x_8) => ({
        Address: r_5.Address,
        BuildingDetail: r_5.BuildingDetail,
        DossierClient: r_5.DossierClient,
        DossierType: r_5.DossierType,
        InspectionLocation: r_5.InspectionLocation,
        InspectionLocationBerging: r_5.InspectionLocationBerging,
        InspectionLocationGaragebox: r_5.InspectionLocationGaragebox,
        InspectionLocationOther: r_5.InspectionLocationOther,
        InspectionLocationStaanplaats: r_5.InspectionLocationStaanplaats,
        IsUserOwnerOfArea: x_8,
        OwnerStatus: r_5.OwnerStatus,
    }), useFormValidator(addressCase.Validator, (r_4, x_7) => ({
        Address: x_7,
        BuildingDetail: r_4.BuildingDetail,
        DossierClient: r_4.DossierClient,
        DossierType: r_4.DossierType,
        InspectionLocation: r_4.InspectionLocation,
        InspectionLocationBerging: r_4.InspectionLocationBerging,
        InspectionLocationGaragebox: r_4.InspectionLocationGaragebox,
        InspectionLocationOther: r_4.InspectionLocationOther,
        InspectionLocationStaanplaats: r_4.InspectionLocationStaanplaats,
        OwnerStatus: r_4.OwnerStatus,
    }), useFormValidator(buildingDetail.Validator, (r_3, x_6) => ({
        BuildingDetail: isNullOrEmpty(x_6.Value) ? (void 0) : (new NonEmptyString(x_6.Value)),
        DossierClient: r_3.DossierClient,
        DossierType: r_3.DossierType,
        InspectionLocation: r_3.InspectionLocation,
        InspectionLocationBerging: r_3.InspectionLocationBerging,
        InspectionLocationGaragebox: r_3.InspectionLocationGaragebox,
        InspectionLocationOther: r_3.InspectionLocationOther,
        InspectionLocationStaanplaats: r_3.InspectionLocationStaanplaats,
        OwnerStatus: r_3.OwnerStatus,
    }), useFormValidator(dossierClientData.Validator, (r_2, x_5) => ({
        DossierClient: x_5,
        DossierType: r_2.DossierType,
        InspectionLocation: r_2.InspectionLocation,
        InspectionLocationBerging: r_2.InspectionLocationBerging,
        InspectionLocationGaragebox: r_2.InspectionLocationGaragebox,
        InspectionLocationOther: r_2.InspectionLocationOther,
        InspectionLocationStaanplaats: r_2.InspectionLocationStaanplaats,
        OwnerStatus: new OwnerStatus_2(8),
    }), useFormValidator(inspectionLocationData.Validator, (r_1, x_4) => {
        const matchValue_6 = x_4.Value;
        switch (matchValue_6.tag) {
            case 14:
            case 16:
            case 15: {
                return {
                    DossierType: r_1.DossierType,
                    InspectionLocation: x_4,
                    InspectionLocationBerging: inspectionLocationBerging.State,
                    InspectionLocationGaragebox: inspectionLocationGaragebox.State,
                    InspectionLocationOther: void 0,
                    InspectionLocationStaanplaats: inspectionLocationStaanplaats.State,
                };
            }
            case 23: {
                return {
                    DossierType: r_1.DossierType,
                    InspectionLocation: x_4,
                    InspectionLocationBerging: void 0,
                    InspectionLocationGaragebox: void 0,
                    InspectionLocationOther: validateOther(r_1, residentialOther),
                    InspectionLocationStaanplaats: void 0,
                };
            }
            case 12: {
                return {
                    DossierType: r_1.DossierType,
                    InspectionLocation: x_4,
                    InspectionLocationBerging: void 0,
                    InspectionLocationGaragebox: void 0,
                    InspectionLocationOther: validateOther(r_1, nonResidentialOther),
                    InspectionLocationStaanplaats: void 0,
                };
            }
            case 3: {
                return {
                    DossierType: r_1.DossierType,
                    InspectionLocation: x_4,
                    InspectionLocationBerging: void 0,
                    InspectionLocationGaragebox: void 0,
                    InspectionLocationOther: validateOther(r_1, publicOther),
                    InspectionLocationStaanplaats: void 0,
                };
            }
            case 30: {
                return {
                    DossierType: r_1.DossierType,
                    InspectionLocation: x_4,
                    InspectionLocationBerging: void 0,
                    InspectionLocationGaragebox: void 0,
                    InspectionLocationOther: validateOther(r_1, inSocialUseOther),
                    InspectionLocationStaanplaats: void 0,
                };
            }
            default: {
                return {
                    DossierType: r_1.DossierType,
                    InspectionLocation: x_4,
                    InspectionLocationBerging: void 0,
                    InspectionLocationGaragebox: void 0,
                    InspectionLocationOther: void 0,
                    InspectionLocationStaanplaats: void 0,
                };
            }
        }
    }, useFormValidator(dossierTypeData.Validator, (unitVar_3, x_2) => {
        if (x_2.Value.tag === 1) {
            return {
                DossierType: x_2,
            };
        }
        else {
            const s = useFormValidator(asbestInventoryData.Validator, (unitVar_4, x_3) => ({
                AsbestInventoryData: x_3,
                Value: x_3.Value,
            }), useForm()).Validate();
            if (s == null) {
                return {
                    DossierType: x_2,
                };
            }
            else {
                return {
                    DossierType: TypeOfDossierData___UnsafeCreate_Z1D754B91(new TypeOfDossier_1(0, s.Value)),
                };
            }
        }
    }, useForm()))))))))))))))))))));
    const comment = useFeliz_React__React_useState_Static_1505("")[0];
    const patternInput_9 = useFeliz_React__React_useState_Static_1505(true);
    const setDisableDiscountTextInput = patternInput_9[1];
    const patternInput_10 = useFeliz_React__React_useState_Static_1505(new DiscountOption(0));
    const discountOption = patternInput_10[0];
    const isUrgent = useToggle(false);
    const floorplan = useFormField(void 0, some);
    const cadastralRecords = useFormField(void 0, some);
    const otherPropertyDocument = useFormField(void 0, some);
    const patternInput_11 = useFeliz_React__React_useState_Static_1505(isPartner ? (new CommentType(1)) : (new CommentType(0)));
    return createElement(Col, {
        classes: singleton_1(Gap.M),
        children: toList(delay(() => append(singleton(createElement(Row, {
            classes: empty(),
            children: singleton_1(createElement(Col, {
                classes: empty(),
                children: singleton_1(createElement(ChooseOwner, {
                    ownerOption: ownerOption,
                    ownerCompanyForm: ownerCompany,
                    ownerPersonForm: ownerPerson,
                })),
            })),
        })), delay(() => append((!isPartner) ? append(singleton(createElement("h2", {
            children: ["Type"],
        })), delay(() => {
            let elements;
            return singleton(MuiHelpers_createElement(RadioGroup, [["row", false], (elements = [OptionField(dossierTypeData, new TypeOfDossier_1(0, new AsbestInventory(0)), "Asbestinventaris", "", false), OptionField(dossierTypeData, new TypeOfDossier_1(1), "Monstername", "", false)], ["children", Interop_reactApi.Children.toArray(Array.from(elements))])]));
        })) : empty_1(), delay(() => {
            let matchValue_15;
            return append((matchValue_15 = dossierTypeData.FieldValue, (matchValue_15 == null) ? singleton(null) : ((matchValue_15.tag === 1) ? singleton(null) : append(singleton(createElement("h2", {
                children: ["Aanleiding van de asbestinventaris"],
            })), delay(() => {
                let elements_1;
                return singleton(MuiHelpers_createElement(RadioGroup, [["row", false], (elements_1 = AsbestInventoryDataOptions(asbestInventoryData, profile), ["children", Interop_reactApi.Children.toArray(Array.from(elements_1))])]));
            })))), delay(() => {
                let elems_3, elements_2;
                return append(singleton(createElement("div", createObj(ofArray([["hidden", true], (elems_3 = [createElement(Row, {
                    classes: empty(),
                    children: singleton_1(createElement(Col, {
                        classes: empty(),
                        children: ofArray([createElement("h2", {
                            children: ["Opdrachtgever"],
                        }), MuiHelpers_createElement(RadioGroup, [["row", false], (elements_2 = [OptionField(dossierClientData, new DossierClient(0), "Eigenaar", "", false), OptionField(dossierClientData, new DossierClient(1), "Gevolmachtigde", "", false), OptionField(dossierClientData, new DossierClient(2), "Vereniging van mede-eigenaars", "", false)], ["children", Interop_reactApi.Children.toArray(Array.from(elements_2))])])]),
                    })),
                })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => append(singleton(createElement(Row, {
                    classes: empty(),
                    children: singleton_1(createElement(Col, {
                        classes: singleton_1(MarginBottom.L),
                        children: singleton_1(createElement(ChooseInspectionLocationFormCheckbox, {
                            inspectionLocationData: inspectionLocationData,
                            residentialOther: residentialOther,
                            nonResidentialOther: nonResidentialOther,
                            inSocialUseOther: inSocialUseOther,
                            publicOther: publicOther,
                            selectedLocationGroups: toList(delay(() => append(singleton(new InspectionLocationType(0)), delay(() => append(singleton(new InspectionLocationType(1)), delay(() => (isPartner ? append(singleton(new InspectionLocationType(2)), delay(() => singleton(new InspectionLocationType(3)))) : empty_1()))))))),
                            hideGroupSelection: isPartner,
                            residentialBerging: residentialBerging,
                            residentialGaragebox: residentialGaragebox,
                        })),
                    })),
                })), delay(() => append(singleton(createElement(Col, {
                    classes: singleton_1(Gap.M),
                    children: toList(delay(() => append(singleton(createElement("h2", {
                        children: ["Statuut eigenaar"],
                    })), delay(() => {
                        let elements_3;
                        return append(singleton(MuiHelpers_createElement(RadioGroup, [["row", false], (elements_3 = toList(delay(() => append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(0), "Particulier", "", false)), delay(() => append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(6), "Onderneming", "", false)), delay(() => append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(7), "VME (vereniging van medeeigneaars)", "", false)), delay(() => append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(1), "Sociale huisvestingsmaatschappij", "", false)), delay(() => {
                            let matchValue_17;
                            return append((dossierCreatePageSource.tag === 0) ? ((matchValue_17 = inspectionLocationData.FieldValue, (matchValue_17 != null) ? ((matchValue_17.tag === 0) ? append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(3), "Overheid/Parastatale (Vlaams gewest)", "", false)), delay(() => append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(4), "Overheid/Parastatale (Lokaal/Regionaal)", "", false)), delay(() => singleton(OptionField(ownerStatusData, new OwnerStatus_2(5), "Overheid/Parastatale (Federaal)", "", false)))))) : ((matchValue_17.tag === 1) ? append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(3), "Overheid/Parastatale (Vlaams gewest)", "", false)), delay(() => append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(4), "Overheid/Parastatale (Lokaal/Regionaal)", "", false)), delay(() => singleton(OptionField(ownerStatusData, new OwnerStatus_2(5), "Overheid/Parastatale (Federaal)", "", false)))))) : ((matchValue_17.tag === 2) ? append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(3), "Overheid/Parastatale (Vlaams gewest)", "", false)), delay(() => append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(4), "Overheid/Parastatale (Lokaal/Regionaal)", "", false)), delay(() => singleton(OptionField(ownerStatusData, new OwnerStatus_2(5), "Overheid/Parastatale (Federaal)", "", false)))))) : ((matchValue_17.tag === 3) ? append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(3), "Overheid/Parastatale (Vlaams gewest)", "", false)), delay(() => append(singleton(OptionField(ownerStatusData, new OwnerStatus_2(4), "Overheid/Parastatale (Lokaal/Regionaal)", "", false)), delay(() => singleton(OptionField(ownerStatusData, new OwnerStatus_2(5), "Overheid/Parastatale (Federaal)", "", false)))))) : singleton(null))))) : singleton(null))) : singleton(null), delay(() => ((dossierCreatePageSource.tag === 0) ? singleton(OptionField(ownerStatusData, new OwnerStatus_2(8), "Andere", "", false)) : singleton(null))));
                        })))))))))), ["children", Interop_reactApi.Children.toArray(Array.from(elements_3))])])), delay(() => {
                            let otherfieldDisabled;
                            const matchValue_19 = ownerStatusData.FieldValue;
                            let pattern_matching_result;
                            if (matchValue_19 != null) {
                                if (matchValue_19.tag === 8) {
                                    pattern_matching_result = 0;
                                }
                                else {
                                    pattern_matching_result = 1;
                                }
                            }
                            else {
                                pattern_matching_result = 1;
                            }
                            switch (pattern_matching_result) {
                                case 0: {
                                    otherfieldDisabled = false;
                                    break;
                                }
                                case 1: {
                                    otherfieldDisabled = true;
                                    break;
                                }
                            }
                            return (!otherfieldDisabled) ? singleton(createElement(Col, {
                                classes: singleton_1(PaddingLeft.L),
                                children: singleton_1(TextFieldDisabled(ownerStatusOther, "", "", true, otherfieldDisabled)),
                            })) : empty_1();
                        }));
                    })))),
                })), delay(() => {
                    let matchValue_20, xs_1, elements_4;
                    const checkboxField = (label, toggleHook) => MuiHelpers_createElement(FormControlLabel, [["label", label], ["control", MuiHelpers_createElement(Checkbox, [["checked", toggleHook.State], ["onChange", (n) => {
                        toggleHook.Toggle();
                    }]])]]);
                    return append((matchValue_20 = inspectionLocationData.FieldValue, (matchValue_20 != null) ? ((matchValue_20.tag === 14) ? singleton((xs_1 = [createElement("h2", {
                        children: ["Zijn er een of meerdere van de volgende extra ruimtes aanwezig"],
                    }), MuiHelpers_createElement(RadioGroup, [["row", false], (elements_4 = [checkboxField(InspectionLocation_extra(new InspectionLocationExtra(0)), inspectionLocationBerging), checkboxField(InspectionLocation_extra(new InspectionLocationExtra(1)), inspectionLocationStaanplaats), checkboxField(InspectionLocation_extra(new InspectionLocationExtra(2)), inspectionLocationGaragebox)], ["children", Interop_reactApi.Children.toArray(Array.from(elements_4))])])], react.createElement(react.Fragment, {}, ...xs_1))) : ((matchValue_20.tag === 16) ? singleton((xs_1 = [createElement("h2", {
                        children: ["Zijn er een of meerdere van de volgende extra ruimtes aanwezig"],
                    }), MuiHelpers_createElement(RadioGroup, [["row", false], (elements_4 = [checkboxField(InspectionLocation_extra(new InspectionLocationExtra(0)), inspectionLocationBerging), checkboxField(InspectionLocation_extra(new InspectionLocationExtra(1)), inspectionLocationStaanplaats), checkboxField(InspectionLocation_extra(new InspectionLocationExtra(2)), inspectionLocationGaragebox)], ["children", Interop_reactApi.Children.toArray(Array.from(elements_4))])])], react.createElement(react.Fragment, {}, ...xs_1))) : ((matchValue_20.tag === 15) ? singleton((xs_1 = [createElement("h2", {
                        children: ["Zijn er een of meerdere van de volgende extra ruimtes aanwezig"],
                    }), MuiHelpers_createElement(RadioGroup, [["row", false], (elements_4 = [checkboxField(InspectionLocation_extra(new InspectionLocationExtra(0)), inspectionLocationBerging), checkboxField(InspectionLocation_extra(new InspectionLocationExtra(1)), inspectionLocationStaanplaats), checkboxField(InspectionLocation_extra(new InspectionLocationExtra(2)), inspectionLocationGaragebox)], ["children", Interop_reactApi.Children.toArray(Array.from(elements_4))])])], react.createElement(react.Fragment, {}, ...xs_1))) : singleton(null)))) : singleton(null)), delay(() => {
                        let matchValue_21;
                        return append((matchValue_21 = inspectionLocationData.FieldValue, (matchValue_21 != null) ? ((matchValue_21.tag === 14) ? singleton(TextField(buildingDetail, "Gebouwdeel, vleugel, blok", "", false)) : ((matchValue_21.tag === 16) ? singleton(TextField(buildingDetail, "Gebouwdeel, vleugel, blok", "", false)) : ((matchValue_21.tag === 15) ? singleton(TextField(buildingDetail, "Gebouwdeel, vleugel, blok", "", false)) : ((matchValue_21.tag === 17) ? singleton(TextField(buildingDetail, "Gebouwdeel, vleugel, blok", "", false)) : singleton(null))))) : singleton(null)), delay(() => append(singleton(TextField(yearOfConstruction, "Jaar van constructie", "", false)), delay(() => append(yearOfConstructionRequiredError ? singleton(createElement("div", {
                            className: join(" ", [error]),
                            children: "Vereist.",
                        })) : empty_1(), delay(() => append(singleton(TextField(yearOfRenovation, "Jaar van renovatie", "", false)), delay(() => append(yearOfConstructionRequiredError ? singleton(createElement("div", {
                            className: join(" ", [error]),
                            children: "Vereist.",
                        })) : empty_1(), delay(() => append(singleton(TextField(numberOfEntrances, "Aantal ingangen in het gebouw", "", false)), delay(() => append(singleton(TextField(pipleIsolationMeters, "Leidingisolatie (lopende meter)", "", false)), delay(() => append(singleton(TextField(hallwaysPerLevel, "Gangen per verdiep", "", false)), delay(() => {
                            let matchValue_22;
                            return append((matchValue_22 = inspectionLocationData.FieldValue, (matchValue_22 != null) ? ((matchValue_22.tag === 22) ? append(singleton(TextField(sharedAreaOption1, "Tellerlokalen", "", false)), delay(() => append(singleton(TextField(sharedAreaOption2, "Vuilnislokaal", "", false)), delay(() => append(singleton(TextField(sharedAreaOption3, "Fietsberging", "", false)), delay(() => singleton(TextField(sharedAreaOption4, "Gemene Delen Option 4", "", false)))))))) : singleton(null)) : singleton(null)), delay(() => append(singleton(MuiHelpers_createElement(FormControlLabel, [["label", ["Stooklokaal"]], ["control", MuiHelpers_createElement(Switch, [["checked", boilerRoom.State]])], ["onChange", (e) => {
                                const s_1 = Browser_Types_Event__Event_get_Checked(e);
                                boilerRoom.Toggle();
                            }]])), delay(() => {
                                let elements_5;
                                return append(singleton(createElement(Row, {
                                    classes: empty(),
                                    children: singleton_1(createElement(Col, {
                                        classes: singleton_1(MarginRight.Xl),
                                        children: ofArray([createElement("h2", {
                                            children: ["Eigenaar gebruiker van het inspectiegebied"],
                                        }), MuiHelpers_createElement(RadioGroup, [["row", false], (elements_5 = [OptionField(isUserOwnerOfArea, true, "Ja: bv. u woont of werk er", "", false), OptionField(isUserOwnerOfArea, false, "Nee: bv. u verhuurt de eigendom", "", false)], ["children", Interop_reactApi.Children.toArray(Array.from(elements_5))])])]),
                                    })),
                                })), delay(() => {
                                    let matchValue_23;
                                    const inspectionLocationAddressLabel = (dossierCreatePageSource.tag === 2) ? "Zelfde als eigenaar" : ((dossierCreatePageSource.tag === 0) ? "Zelfde als klant" : "Zelfde als eigenaar");
                                    const sameAsCustomerAddress = ((matchValue_23 = ownerOption.FieldValue, (matchValue_23 == null) ? false : ((matchValue_23.tag === 0) ? ((((!isNullOrEmpty(ownerPerson.AddressField.StreetField.FieldValue)) && (!isNullOrEmpty(ownerPerson.AddressField.City.FieldValue))) && (!isNullOrEmpty(ownerPerson.AddressField.NumberField.FieldValue))) && (!isNullOrEmpty(ownerPerson.AddressField.PostalCodeField.FieldValue))) : ((((!isNullOrEmpty(ownerCompany.AddressField.StreetField.FieldValue)) && (!isNullOrEmpty(ownerCompany.AddressField.City.FieldValue))) && (!isNullOrEmpty(ownerCompany.AddressField.NumberField.FieldValue))) && (!isNullOrEmpty(ownerCompany.AddressField.PostalCodeField.FieldValue)))))) ? MuiHelpers_createElement(FormControlLabel, [["label", inspectionLocationAddressLabel], ["control", MuiHelpers_createElement(Checkbox, [["checked", isSameAddress]])], ["onChange", (e_1) => {
                                        const s_2 = Browser_Types_Event__Event_get_Checked(e_1);
                                        patternInput_4[1](s_2);
                                        if (s_2) {
                                            const matchValue_24 = ownerOption.FieldValue;
                                            if (matchValue_24 == null) {
                                            }
                                            else if (matchValue_24.tag === 0) {
                                                addressCase.StreetField.SetFieldValue(ownerPerson.AddressField.StreetField.FieldValue);
                                                addressCase.BusField.SetFieldValue(ownerPerson.AddressField.BusField.FieldValue);
                                                addressCase.City.SetFieldValue(ownerPerson.AddressField.City.FieldValue);
                                                addressCase.NumberField.SetFieldValue(ownerPerson.AddressField.NumberField.FieldValue);
                                                addressCase.PostalCodeField.SetFieldValue(ownerPerson.AddressField.PostalCodeField.FieldValue);
                                            }
                                            else {
                                                addressCase.StreetField.SetFieldValue(ownerCompany.AddressField.StreetField.FieldValue);
                                                addressCase.BusField.SetFieldValue(ownerCompany.AddressField.BusField.FieldValue);
                                                addressCase.City.SetFieldValue(ownerCompany.AddressField.City.FieldValue);
                                                addressCase.NumberField.SetFieldValue(ownerCompany.AddressField.NumberField.FieldValue);
                                                addressCase.PostalCodeField.SetFieldValue(ownerCompany.AddressField.PostalCodeField.FieldValue);
                                            }
                                        }
                                        else {
                                            addressCase.StreetField.SetFieldValue("");
                                            addressCase.BusField.SetFieldValue("");
                                            addressCase.City.SetFieldValue("");
                                            addressCase.NumberField.SetFieldValue("");
                                            addressCase.PostalCodeField.SetFieldValue("");
                                        }
                                    }]]) : null;
                                    return append(singleton(createElement(CreateAddressFormWithReset, {
                                        addressForm: addressCase,
                                        resetOption: sameAsCustomerAddress,
                                        heading: "Adres Inspectielocatie",
                                        isSameAddress: isSameAddress,
                                    })), delay(() => append(isPartner ? append(singleton(createElement("h2", {
                                        children: ["Eigendom"],
                                    })), delay(() => append(singleton(FileField(cadastralRecords, "Upload Kadastrale legger", "", false)), delay(() => append(singleton(FileField(floorplan, "Upload Grondplan", "", false)), delay(() => singleton(FileField(otherPropertyDocument, "Upload Andere", "", false)))))))) : empty_1(), delay(() => append(singleton(createElement(Col, {
                                        classes: empty(),
                                        children: toList(delay(() => {
                                            let matchValue_25, partners_1;
                                            return append((matchValue_25 = partners, (matchValue_25 == null) ? singleton(null) : ((partners_1 = matchValue_25, append(singleton(createElement("h2", {
                                                children: ["Partner"],
                                            })), delay(() => {
                                                let elems_7;
                                                const options = toArray(delay(() => append(singleton(PartnerOption_get_empty()), delay(() => append(singleton(PartnerOption_get_none()), delay(() => toArray_1(map_1((partner) => (new PartnerOption(NonEmptyString___UnsafeUnwrap_Z73AD07C(partner.CompanyName), partner.Id.Value, partner.IsCibPartner, partner.PartnerType, partner.CompensationAmount, partner.CompensationAmountEpc)), partners_1))))))));
                                                return append(singleton(MuiHelpers_createElement(FormControl, [["error", selectPartnerError], (elems_7 = [MuiHelpers_createElement(Autocomplete, [["id", "partner-combo-box-label"], ["options", Array.from(options)], ["value", partnerOption], ["getOptionSelected", (delegateArg, delegateArg_1) => (delegateArg.Id === delegateArg_1.Id)], ["onChange", (_arg_1, v_3, _arg_1_1) => {
                                                    const partner_1 = v_3;
                                                    if (!(partner_1 == null)) {
                                                        patternInput_6[1](partner_1);
                                                        patternInput_2[1](partner_1.IsCibPartner);
                                                        if (partner_1.Id !== PartnerOption_get_empty().Id) {
                                                            setSelectPartnerError(false);
                                                        }
                                                    }
                                                }], ["renderInput", (params$0027) => MuiHelpers_createElement(TextField_1, toList(delay(() => append(singleton(["variant", "outlined"]), delay(() => append(singleton(["label", "Partner"]), delay(() => (Object.entries(params$0027)))))))))], ["renderOption", (delegateArg_2, delegateArg_1_1) => {
                                                    const partnerOption_1 = delegateArg_2;
                                                    const xs_4 = toList(delay(() => {
                                                        let children_3, children_1;
                                                        return (partnerOption_1.PartnerType.tag === 1) ? singleton((children_3 = ofArray([MuiHelpers_createElement(Chip, [["label", "Syndic"], ["className", MarginRight.Xs]]), createElement("span", {
                                                            children: [partnerOption_1.Label],
                                                        })]), createElement("div", {
                                                            children: Interop_reactApi.Children.toArray(Array.from(children_3)),
                                                        }))) : (partnerOption_1.IsCibPartner ? singleton((children_1 = ofArray([MuiHelpers_createElement(Chip, [["label", "CIB"], ["className", MarginRight.Xs]]), createElement("span", {
                                                            children: [partnerOption_1.Label],
                                                        })]), createElement("div", {
                                                            children: Interop_reactApi.Children.toArray(Array.from(children_1)),
                                                        }))) : singleton(createElement("span", {
                                                            children: [partnerOption_1.Label],
                                                        })));
                                                    }));
                                                    return react.createElement(react.Fragment, {}, ...xs_4);
                                                }], ["filterOptions", (opts_1, s_3) => Array.from(filterPartnerOptions(opts_1, s_3.inputValue))], ["getOptionLabel", (partner_2) => partner_2.Label]])], ["children", Interop_reactApi.Children.toArray(Array.from(elems_7))])])), delay(() => (selectPartnerError ? singleton(createElement(Row, {
                                                    classes: ofArray([MarginTop.M, error]),
                                                    children: singleton_1("Selecteer een partner of geen"),
                                                })) : empty_1())));
                                            }))))), delay(() => append((equals(dossierCreatePageSource, new DossierCreatePageSource(0)) && (equals(partnerOption, PartnerOption_get_empty()) ? true : equals(partnerOption, PartnerOption_get_none()))) ? singleton(null) : (equals(dossierCreatePageSource, new DossierCreatePageSource(1)) ? singleton(createElement(Col, {
                                                classes: empty(),
                                                children: ofArray([createElement("h2", {
                                                    children: ["Vergoedingen"],
                                                }), createElement(CompensationOptionsRestricted, compensationData)]),
                                            })) : singleton(createElement(CompensationOptions, {
                                                compensationData: compensationData,
                                                compensationCustom: compensationCustom_1,
                                                showHeader: true,
                                            }))), delay(() => append(singleton(createElement("h2", {
                                                children: ["Prijs Offerte"],
                                            })), delay(() => singleton(NumberFieldDecimal(customPrice, "Prijs Offerte", "", false))))))));
                                        })),
                                    })), delay(() => append((!isPartner) ? append(singleton(createElement(Row, {
                                        classes: ofArray([Gap.M, MarginTop.S]),
                                        children: toList(delay(() => {
                                            let elems_8;
                                            const buttonDisabled = partnerOption.Id === -1;
                                            return singleton(MuiHelpers_createElement(FormControlLabel, [["label", [createElement("div", createObj(singleton_1((elems_8 = [createElement(Row, {
                                                classes: empty(),
                                                children: ofArray([createElement(Col, {
                                                    classes: empty(),
                                                    children: singleton_1("Automatisch mail verzenden naar "),
                                                }), createElement(Col, {
                                                    classes: ofArray([Boldness.b700, MarginLeft.Xs, MarginRight.Xs]),
                                                    children: singleton_1("partner"),
                                                }), createElement(Col, {
                                                    classes: empty(),
                                                    children: singleton_1("(opening dossier en vraag om digitaal het opdrachtformulier te ondertekenen)"),
                                                })]),
                                            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_8))]))))]], ["disabled", buttonDisabled], ["control", MuiHelpers_createElement(Switch, [["checked", (partnerOption.Id > 0) && sendMailToPartner.State]])], ["onChange", (e_2) => {
                                                const s_4 = Browser_Types_Event__Event_get_Checked(e_2);
                                                sendMailToPartner.Toggle();
                                            }]]));
                                        })),
                                    })), delay(() => append(singleton(MuiHelpers_createElement(FormControlLabel, [["label", "Geen standaard dossier"], ["control", MuiHelpers_createElement(Checkbox, [["checked", manualInvoice.State], ["onChange", (e_3) => {
                                        const _arg_2 = Browser_Types_Event__Event_get_Checked(e_3);
                                        manualInvoice.Toggle();
                                    }]])]])), delay(() => {
                                        let elements_8;
                                        return singleton(MuiHelpers_createElement(Grid, [["spacing", 2], ["container", true], (elements_8 = toList(delay(() => {
                                            let elements_6, elems_9;
                                            return append(singleton(MuiHelpers_createElement(Grid, [["item", true], ["xs", 2], (elements_6 = [MuiHelpers_createElement(FormControl, [["fullWidth", true], (elems_9 = toList(delay(() => {
                                                const discountOptions = [new DiscountOption(0), new DiscountOption(2), new DiscountOption(1)];
                                                return singleton(MuiHelpers_createElement(Autocomplete, [["id", "discount-combo-box-label"], ["options", Array.from(discountOptions)], ["value", discountOption], ["getOptionSelected", equals], ["onChange", (_arg_3, v_4, _arg_1_2) => {
                                                    SafeNotNullCheck(v_4, (discOption) => {
                                                        patternInput_10[1](discOption);
                                                        switch (discOption.tag) {
                                                            case 1:
                                                            case 2: {
                                                                manualInvoice.On();
                                                                setDisableDiscountTextInput(false);
                                                                break;
                                                            }
                                                            default: {
                                                                setDisableDiscountTextInput(true);
                                                            }
                                                        }
                                                    });
                                                }], ["renderInput", (params$0027_1) => MuiHelpers_createElement(TextField_1, toList(delay(() => append(singleton(["variant", "outlined"]), delay(() => append(singleton(["label", "Soort korting"]), delay(() => (Object.entries(params$0027_1)))))))))], ["getOptionLabel", DiscountOption__get_Label]]));
                                            })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_9))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_6))])])), delay(() => {
                                                let elements_7;
                                                return singleton(MuiHelpers_createElement(Grid, [["item", true], ["xs", 4], (elements_7 = [NumberFieldFloat(discount, "Korting", "", false, patternInput_9[0], (discountOption.tag === 1) ? "€" : ((discountOption.tag === 2) ? "%" : ""))], ["children", Interop_reactApi.Children.toArray(Array.from(elements_7))])]));
                                            }));
                                        })), ["children", Interop_reactApi.Children.toArray(Array.from(elements_8))])]));
                                    })))) : empty_1(), delay(() => append(equals(dossierCreatePageSource, new DossierCreatePageSource(1)) ? singleton(MuiHelpers_createElement(FormControlLabel, [["className", error], ["label", "Dringend"], ["control", MuiHelpers_createElement(Checkbox, [["checked", isUrgent.State], ["onChange", (n_1) => {
                                        isUrgent.Toggle();
                                    }]])]])) : empty_1(), delay(() => singleton(createElement(Row, {
                                        classes: ofArray([Gap.M, MarginTop.L]),
                                        children: toList(delay(() => {
                                            let matchValue_27, url;
                                            return append((matchValue_27 = backUrl, (matchValue_27 == null) ? singleton(null) : ((url = matchValue_27, singleton(MuiHelpers_createElement(Button, [["disabled", disable], ["color", "default"], ["variant", "contained"], ["onClick", (_arg_4) => {
                                                RouterModule_nav(ofArray(url), 1, 1);
                                            }], ["children", Interop_reactApi.Children.toArray(["Annuleren"])]]))))), delay(() => {
                                                let elems_15;
                                                return singleton(createElement("div", createObj(ofArray([["hidden", true], (elems_15 = [MuiHelpers_createElement(Button, [["id", "dossier-create-button"], ["ref", buttonRef], ["disabled", disable], ["color", "primary"], ["variant", "contained"], ["onClick", (_arg) => {
                                                    if ((partnerOption.Id === PartnerOption_get_empty().Id) ? ((setSelectPartnerError(true), false)) : true) {
                                                        iterate((data) => {
                                                            if ((data.OwnerStatus.Value.tag === 8) ? (data.OwnerStatusOther != null) : true) {
                                                                iterate((owner) => {
                                                                    const inspectionLocationAddress = (dossierCreatePageSource.tag === 0) ? data.Address : ((dossierCreatePageSource.tag === 2) ? (isSameAddress ? DossierOwner__get_Address(owner) : data.Address) : data.Address);
                                                                    setDisable(true);
                                                                    onCreateDossier(new CreateQuoteData(data.DossierType, data.InspectionLocation, data.InspectionLocationOther, data.DossierClient, data.BuildingDetail, void 0, data.YearsOfConstruction, data.YearOfRenovation, void 0, data.IsUserOwnerOfArea.Value, inspectionLocationAddress, false, new DossierStatus(0), (partnerOption.Id === 0) ? (void 0) : (new PartnerId(partnerOption.Id)), void 0, owner, manualInvoice.State, false, void 0, void 0, data.OwnerStatus, data.OwnerStatusOther, (discountOption.tag === 1) ? (new TypeOfDiscount(1, data.Discount)) : ((discountOption.tag === 2) ? (new TypeOfDiscount(2, data.Discount)) : (new TypeOfDiscount(0))), patternInput_2[0], data.InspectionLocationBerging, data.InspectionLocationStaanplaats, data.InspectionLocationGaragebox, isUrgent.State, data.Compensation, false, data.CustomPrice, data.NumberOfEntrances, data.HallwaysPerLevel, data.PipeIsolationMeters, boilerRoom.State, data.SharedAreaOption1, data.SharedAreaOption2, data.SharedAreaOption3, data.SharedAreaOption4))((comment.length > 0) ? (new CommentData(comment, "", new CommentSource_1(1), patternInput_11[0])) : (void 0))(floorplan.FieldValue)(cadastralRecords.FieldValue)(otherPropertyDocument.FieldValue)(sendMailToPartner.State)(() => {
                                                                        setDisable(false);
                                                                    });
                                                                }, toArray_2(data.DossierOwner));
                                                            }
                                                        }, toArray_2(form.Validate()));
                                                    }
                                                }], ["children", Interop_reactApi.Children.toArray(["Bewaren"])]])], ["children", Interop_reactApi.Children.toArray(Array.from(elems_15))])]))));
                                            }));
                                        })),
                                    }))))))))))));
                                }));
                            }))));
                        }))))))))))))))));
                    }));
                }))))));
            }));
        })))))),
    });
}

export function CreateQuoteStepperPage(createQuoteStepperPageInputProps) {
    let children_2;
    const getImage = createQuoteStepperPageInputProps.getImage;
    const api = createQuoteStepperPageInputProps.api;
    const compensation = createQuoteStepperPageInputProps.compensation;
    const dossierCreatePageSource = createQuoteStepperPageInputProps.dossierCreatePageSource;
    const setPartnerId = createQuoteStepperPageInputProps.setPartnerId;
    const partnersList = createQuoteStepperPageInputProps.partnersList;
    const setCustomer = createQuoteStepperPageInputProps.setCustomer;
    const customer = createQuoteStepperPageInputProps.customer;
    const onCreateCustomer = createQuoteStepperPageInputProps.onCreateCustomer;
    const onCreateQuote = createQuoteStepperPageInputProps.onCreateQuote;
    const customers = createQuoteStepperPageInputProps.customers;
    const getCustomer = createQuoteStepperPageInputProps.getCustomer;
    const customerUrl = createQuoteStepperPageInputProps.customerUrl;
    const patternInput = useFeliz_React__React_useState_Static_1505(0);
    const setActiveStep = patternInput[1];
    const activeStep = patternInput[0] | 0;
    const patternInput_1 = useFeliz_React__React_useState_Static_1505([false, false, false, false]);
    const stepsCompleted = patternInput_1[0];
    const setStepsCompleted = patternInput_1[1];
    const patternInput_2 = useFeliz_React__React_useState_Static_1505(void 0);
    const dossierData = patternInput_2[0];
    const patternInput_3 = useFeliz_React__React_useState_Static_1505(void 0);
    const dossierDataContact = patternInput_3[0];
    const patternInput_4 = useFeliz_React__React_useState_Static_1505(void 0);
    const patternInput_5 = useFeliz_React__React_useState_Static_1505(CustomerOption_get_none());
    const patternInput_6 = useFeliz_React__React_useState_Static_1505(false);
    const setShowCustomerForm = patternInput_6[1];
    const dossierCreateButtonRef = useReact_useButtonRef();
    const username = useUsername();
    const patternInput_7 = useFeliz_React__React_useState_Static_1505(false);
    const setCreatingDossier = patternInput_7[1];
    const creatingDossier = patternInput_7[0];
    const topRef = useReact_useElementRef();
    const contact = useFormField(void 0, (arg_2) => some(SelectOptionData$1_Create_Z510A3DC0(arg_2)));
    const contactEmail = useFormField("", PhoneNumber_get_Create());
    const contactName = useFormField("", NonEmptyString_get_Create());
    const invoice = useFormField(void 0, SelectOptionData$1_Create_Z510A3DC0);
    const invoiceCustomerPerson = useCreateCustomerPersonForm("", "", "", "", "", "", "", "", "");
    const invoiceCustomerCompany = useCreateCustomerCompanyForm("", "", "", "", "", "", "", "", "", "", false, false, "", "");
    const invoicingPartySameAsOwner = useToggle(false);
    const invoicePricing = useToggle(false);
    const assignmentDocumentContact = useFormField(new AssignmentDocument(1), SelectOptionData$1_Create_Z510A3DC0);
    const assignmentDocumentOther = useFormField("", NonEmptyString_get_Create());
    const assignmentDocumentLegalRepEmail = useFormField("", NonEmptyString_get_Create());
    const assignmentDocumentSyndicEmail = useFormField("", NonEmptyString_get_Create());
    const isPartnerSelected = useToggle(true);
    const patternInput_8 = useFeliz_React__React_useState_Static_1505(username);
    const setPartnerName = patternInput_8[1];
    const partnerName = patternInput_8[0];
    const partnerToggle = useToggle(isPartnerSelected.State);
    const customerToggle = useToggle(false);
    const emailToggle = useToggle(false);
    const emails = useFormField("", NonEmptyString_get_Create());
    const emailsError = useToggle(false);
    const patternInput_9 = useFeliz_React__React_useState_Static_1505(false);
    const foundCustomer = patternInput_9[0];
    const patternInput_10 = useFeliz_React__React_useState_Static_1505(void 0);
    const patternInput_11 = useFeliz_React__React_useState_Static_1505(void 0);
    const patternInput_12 = useFeliz_React__React_useState_Static_1505(void 0);
    const patternInput_13 = useFeliz_React__React_useState_Static_1505(false);
    const patternInput_14 = useFeliz_React__React_useState_Static_1505(void 0);
    const patternInput_15 = useFeliz_React__React_useState_Static_1505(void 0);
    const patternInput_16 = useFeliz_React__React_useState_Static_1505(void 0);
    const patternInput_17 = useFeliz_React__React_useState_Static_1505(empty());
    const files = patternInput_17[0];
    useReact_useEffect_Z101E1A95(() => {
        let customer_1;
        let pattern_matching_result, customer_2;
        if (customer != null) {
            if ((customer_1 = customer, foundCustomer)) {
                pattern_matching_result = 0;
                customer_2 = customer;
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                invoice.SetFieldValue((customer_2.tag === 1) ? (new Invoiced(2)) : (new Invoiced(1)));
                break;
            }
            case 1: {
                break;
            }
        }
    }, [foundCustomer, customer]);
    const updateStepCompletion = (idx, value, array) => mapIndexed((i, v) => {
        if (i === idx) {
            return value;
        }
        else {
            return v;
        }
    }, array);
    useReact_useEffect_Z101E1A95(() => {
        if (item(activeStep, quoteSteps).tag === 0) {
            if (dossierData == null) {
            }
            else {
                const dossierData_2 = dossierData;
                switch (dossierCreatePageSource.tag) {
                    case 2: {
                        setPartnerName(username);
                        isPartnerSelected.On();
                        break;
                    }
                    case 0: {
                        const matchValue_11 = dossierData_2.SyndicId;
                        if (matchValue_11 == null) {
                            setPartnerName("Partner");
                            isPartnerSelected.Off();
                        }
                        else {
                            const partnerId = matchValue_11;
                            setPartnerName("Partner" + getPartnerType(partnerId, partnersList));
                            isPartnerSelected.On();
                            patternInput_4[1](partnerId);
                            iterate((n) => {
                                n(partnerId);
                            }, toArray_2(setPartnerId));
                        }
                        break;
                    }
                    default: {
                        setPartnerName(username);
                        isPartnerSelected.On();
                    }
                }
                setStepsCompleted(updateStepCompletion(activeStep, true, stepsCompleted));
                setActiveStep(activeStep + 1);
            }
        }
    }, [dossierData]);
    const xs_8 = [(children_2 = toList(delay(() => append(singleton(createElement("span", {
        ref: topRef,
    })), delay(() => {
        let elements_8, elements_1, elements, elements_3, elements_2, elements_5, elements_4, elements_7, elements_6;
        return append(singleton(MuiHelpers_createElement(Stepper, [["activeStep", activeStep], (elements_8 = [MuiHelpers_createElement(Step, [["completed", stepsCompleted[0]], (elements_1 = [MuiHelpers_createElement(StepLabel, [(elements = ["Offertes " + quoteStepString(new QuoteStep(0))], ["children", Interop_reactApi.Children.toArray(Array.from(elements))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_1))])]), MuiHelpers_createElement(Step, [["completed", stepsCompleted[1]], ["className", join(" ", [Boldness.b700])], (elements_3 = [MuiHelpers_createElement(StepLabel, [(elements_2 = [quoteStepString(new QuoteStep(1))], ["children", Interop_reactApi.Children.toArray(Array.from(elements_2))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_3))])]), MuiHelpers_createElement(Step, [["completed", stepsCompleted[2]], (elements_5 = [MuiHelpers_createElement(StepLabel, [(elements_4 = [quoteStepString(new QuoteStep(2))], ["children", Interop_reactApi.Children.toArray(Array.from(elements_4))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_5))])]), MuiHelpers_createElement(Step, [["completed", stepsCompleted[3]], ["className", join(" ", [Boldness.b700])], (elements_7 = [MuiHelpers_createElement(StepLabel, [(elements_6 = [quoteStepString(new QuoteStep(3))], ["children", Interop_reactApi.Children.toArray(Array.from(elements_6))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_7))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_8))])])), delay(() => {
            let elems_9, value_38;
            return append(singleton(createElement("div", createObj(ofArray([["hidden", activeStep !== 0], (elems_9 = [(value_38 = ("Offertes " + quoteStepString(new QuoteStep(0))), createElement("h1", {
                children: [value_38],
            })), createElement(CreateQuoteForm, {
                customerUrl: (customerId) => customerUrl(customerId.Value),
                backUrl: void 0,
                partners: partnersList,
                onCreateDossier: (quoteData) => ((comment_1) => ((floorplan_1) => ((cadastralRecords_1) => ((propertyOther_1) => ((sendEmailToPartner_1) => ((onCompleted) => {
                    patternInput_2[1](quoteData);
                    patternInput_10[1](comment_1);
                    patternInput_14[1](floorplan_1);
                    patternInput_15[1](cadastralRecords_1);
                    patternInput_16[1](propertyOther_1);
                    patternInput_13[1](sendEmailToPartner_1);
                    invoicingPartySameAsOwner.On();
                    const matchValue_13 = quoteData.DossierOwner;
                    if (matchValue_13.tag === 1) {
                        const company = matchValue_13.fields[0];
                        invoice.SetFieldValue(new Invoiced(2));
                        invoiceCustomerCompany.CompanyNameField.SetFieldValue(NonEmptyString___UnsafeUnwrap_Z73AD07C(company.CompanyName));
                        invoiceCustomerCompany.CompanyTypeField.SetFieldValue(defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, company.CompanyType), ""));
                        invoiceCustomerCompany.FirstName.SetFieldValue(defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, company.FirstName), ""));
                        invoiceCustomerCompany.LastName.SetFieldValue(defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, company.LastName), ""));
                        invoiceCustomerCompany.EmailField.SetFieldValue(Email___UnsafeUnwrap_Z27D11339(company.Email));
                        invoiceCustomerCompany.TelephoneField.SetFieldValue(defaultArg(map(PhoneNumber___UnsafeUnwrap_23E45174, company.PhoneNumber), ""));
                        invoiceCustomerCompany.VatNumberField.SetFieldValue(VatNumber___UnsafeUnwrap_18C04ACB(company.VatNumber));
                        invoiceCustomerCompany.AddressField.StreetField.SetFieldValue(company.Address.Street.Value);
                        invoiceCustomerCompany.AddressField.NumberField.SetFieldValue(company.Address.Number.Value);
                        invoiceCustomerCompany.AddressField.BusField.SetFieldValue(defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, company.Address.Bus), ""));
                        invoiceCustomerCompany.AddressField.PostalCodeField.SetFieldValue(company.Address.PostalCode.Value);
                        invoiceCustomerCompany.AddressField.City.SetFieldValue(company.Address.City.Value);
                        invoiceCustomerPerson.FirstNameField.SetFieldValue(defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, company.FirstName), ""));
                        invoiceCustomerPerson.LastNameField.SetFieldValue(defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, company.LastName), ""));
                        if (company.IsVME) {
                            invoiceCustomerCompany.IsVMEField.On();
                        }
                        if (company.IsSocialHousingCompany) {
                            invoiceCustomerCompany.IsSocialHousingCompanyField.On();
                        }
                    }
                    else {
                        const person = matchValue_13.fields[0];
                        invoice.SetFieldValue(new Invoiced(1));
                        invoiceCustomerPerson.FirstNameField.SetFieldValue(NonEmptyString___UnsafeUnwrap_Z73AD07C(person.FirstName));
                        invoiceCustomerPerson.LastNameField.SetFieldValue(NonEmptyString___UnsafeUnwrap_Z73AD07C(person.LastName));
                        invoiceCustomerPerson.EmailField.SetFieldValue(Email___UnsafeUnwrap_Z27D11339(person.Email));
                        invoiceCustomerPerson.TelephoneField.SetFieldValue(defaultArg(map(PhoneNumber___UnsafeUnwrap_23E45174, person.PhoneNumber), ""));
                        invoiceCustomerPerson.AddressField.StreetField.SetFieldValue(person.Address.Street.Value);
                        invoiceCustomerPerson.AddressField.NumberField.SetFieldValue(person.Address.Number.Value);
                        invoiceCustomerPerson.AddressField.BusField.SetFieldValue(defaultArg(map(NonEmptyString___UnsafeUnwrap_Z73AD07C, person.Address.Bus), ""));
                        invoiceCustomerPerson.AddressField.PostalCodeField.SetFieldValue(person.Address.PostalCode.Value);
                        invoiceCustomerPerson.AddressField.City.SetFieldValue(person.Address.City.Value);
                    }
                    onCompleted();
                })))))),
                isCibDossier: false,
                buttonRef: dossierCreateButtonRef,
                dossierCreatePageSource: dossierCreatePageSource,
                compensation: compensation,
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_9))])])))), delay(() => {
                let elems_10;
                return append(singleton(MuiHelpers_createElement(Modal, [["open", patternInput_6[0]], ["onClose", (_arg_1, v_1) => {
                    setShowCustomerForm(false);
                }], ["children", createElement("div", createObj(ofArray([["style", {
                    width: 100 + "%",
                    height: 100 + "%",
                }], ["className", join(" ", [modal, Padding.Xl])], (elems_10 = [createElement(CreateCustomerForm, {
                    onCreateCustomer: onCreateCustomer,
                    saveButtonText: void 0,
                    backButtonText: void 0,
                    isCibCustomer: false,
                    onBack: () => {
                        setShowCustomerForm(false);
                    },
                })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_10))])])))]])), delay(() => {
                    let elems_11;
                    const findCustomer = createElement(DisplayDeferred, {
                        data: customers,
                        view: (customers_1) => {
                            const options = toArray(delay(() => append(singleton(CustomerOption_get_none()), delay(() => toArray_1(map_1((customer_5) => (new CustomerOption(Customer2__get_CustomerOrCompanyName(customer_5), Customer2__get_Code(customer_5).Value)), customers_1.Data))))));
                            return createElement(FindCustomer, {
                                options: options,
                                customerOption: patternInput_5[0],
                                setCustomerOption: patternInput_5[1],
                                getCustomer: getCustomer,
                                setShowCustomerForm: setShowCustomerForm,
                                reset: () => {
                                    setCustomer(void 0);
                                },
                                setFoundCustomer: patternInput_9[1],
                            });
                        },
                    });
                    return append(singleton(createElement("div", createObj(ofArray([["hidden", activeStep !== 1], (elems_11 = toList(delay(() => {
                        let value_56;
                        return append(singleton((value_56 = quoteStepString(new QuoteStep(1)), createElement("h1", {
                            children: [value_56],
                        }))), delay(() => {
                            let children;
                            const matchValue_14 = dossierData;
                            if (matchValue_14 == null) {
                                return singleton(null);
                            }
                            else {
                                const dossierData_3 = matchValue_14;
                                return singleton((children = ofArray([createElement(ChooseContactQuote, {
                                    contactOption: contact,
                                    partnerName: partnerName,
                                    isPartnerSelected: isPartnerSelected.State,
                                    homeVisitContactName: contactName,
                                    homeVisitContactPhoneNo: contactEmail,
                                    isOptional: true,
                                }), createElement(ChooseInvoicing, {
                                    invoiceOption: invoice,
                                    partnerName: partnerName,
                                    customerControl: findCustomer,
                                    invoicingPartySameAsOwner: invoicingPartySameAsOwner,
                                    setInvoicedValue: invoice.SetFieldValue,
                                    contactOwner: dossierData_3.DossierOwner,
                                    customerPerson: invoiceCustomerPerson,
                                    customerCompany: invoiceCustomerCompany,
                                    isPartnerInvoicingAvailable: isPartnerSelected.State,
                                    foundCustomer: foundCustomer,
                                    dossierCreatePageSource: dossierCreatePageSource,
                                    invoicePricing: invoicePricing,
                                }), createElement(ChooseCertificateContact, {
                                    partnerToggle: partnerToggle,
                                    customerToggle: customerToggle,
                                    emailToggle: emailToggle,
                                    partnerName: partnerName,
                                    emails: emails,
                                    emailsError: emailsError.State,
                                    isPartnerSelected: isPartnerSelected.State,
                                })]), createElement("div", {
                                    children: Interop_reactApi.Children.toArray(Array.from(children)),
                                })));
                            }
                        }));
                    })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_11))])])))), delay(() => {
                        let elems_12, value_60;
                        return append(singleton(createElement("div", createObj(ofArray([["hidden", activeStep !== 2], (elems_12 = [(value_60 = quoteStepString(new QuoteStep(2)), createElement("h1", {
                            children: [value_60],
                        })), createElement(UploadDocumentsStep, {
                            api: api,
                            files: files,
                            setFiles: patternInput_17[1],
                            getImage: getImage,
                        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_12))])])))), delay(() => {
                            let elems_13;
                            return append(singleton(createElement("div", createObj(ofArray([["hidden", activeStep !== 3], (elems_13 = toList(delay(() => {
                                let value_64;
                                return append(singleton((value_64 = quoteStepString(new QuoteStep(3)), createElement("h1", {
                                    children: [value_64],
                                }))), delay(() => {
                                    const matchValue_15 = [dossierData, dossierDataContact];
                                    let pattern_matching_result_1, dossierData_4, dossierDataContact_2;
                                    if (matchValue_15[0] != null) {
                                        if (matchValue_15[1] != null) {
                                            pattern_matching_result_1 = 0;
                                            dossierData_4 = matchValue_15[0];
                                            dossierDataContact_2 = matchValue_15[1];
                                        }
                                        else {
                                            pattern_matching_result_1 = 1;
                                        }
                                    }
                                    else {
                                        pattern_matching_result_1 = 1;
                                    }
                                    switch (pattern_matching_result_1) {
                                        case 0: {
                                            return singleton(createElement(Review, {
                                                quoteData: dossierData_4,
                                                quoteDataContact: dossierDataContact_2,
                                                partnerName: partnerName,
                                                isPartnerSelected: isPartnerSelected.State,
                                            }));
                                        }
                                        case 1: {
                                            return singleton(null);
                                        }
                                    }
                                }));
                            })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_13))])])))), delay(() => singleton(createElement(Row, {
                                classes: ofArray([Gap.M, MarginTop.L]),
                                children: toList(delay(() => {
                                    let elems_14;
                                    const hidden = activeStep === 0;
                                    return append(singleton(createElement("div", createObj(ofArray([["className", alignEnd], ["hidden", hidden], (elems_14 = [MuiHelpers_createElement(Button, [["color", "default"], ["variant", "contained"], ["disabled", hidden ? true : creatingDossier], ["children", "Terug"], ["onClick", (_arg_3) => {
                                        const matchValue_12 = topRef.current;
                                        if (matchValue_12 == null) {
                                        }
                                        else {
                                            const topRef_2 = matchValue_12;
                                            topRef_2.scrollIntoView(true);
                                        }
                                        setActiveStep(activeStep - 1);
                                    }]])], ["children", Interop_reactApi.Children.toArray(Array.from(elems_14))])])))), delay(() => {
                                        let elems_15;
                                        return singleton(createElement("div", createObj(ofArray([["className", alignEnd], (elems_15 = [MuiHelpers_createElement(Button, toList(delay(() => {
                                            let matchValue_16;
                                            return append(singleton(["disabled", (matchValue_16 = item(activeStep, quoteSteps), (matchValue_16.tag === 0) ? false : ((matchValue_16.tag === 2) ? false : ((matchValue_16.tag === 3) && creatingDossier)))]), delay(() => append((activeStep === (length(quoteSteps) - 1)) ? singleton(["color", "secondary"]) : singleton(["color", "primary"]), delay(() => append(singleton(["variant", "contained"]), delay(() => append(singleton(["children", (activeStep === (length(quoteSteps) - 1)) ? "Bevestigen" : "Volgende stap"]), delay(() => singleton(["onClick", (_arg_4) => {
                                                const matchValue_7 = topRef.current;
                                                if (matchValue_7 == null) {
                                                }
                                                else {
                                                    const topRef_1 = matchValue_7;
                                                    topRef_1.scrollIntoView(true);
                                                }
                                                const matchValue_8 = item(activeStep, quoteSteps);
                                                switch (matchValue_8.tag) {
                                                    case 0: {
                                                        iterate((buttonElement) => {
                                                            buttonElement.click();
                                                        }, toArray_2(dossierCreateButtonRef.current));
                                                        break;
                                                    }
                                                    case 2: {
                                                        setStepsCompleted(updateStepCompletion(activeStep, true, stepsCompleted));
                                                        setActiveStep(activeStep + 1);
                                                        break;
                                                    }
                                                    case 3: {
                                                        const matchValue_9 = [dossierData, dossierDataContact];
                                                        let pattern_matching_result_2, dossierData_1, dossierDataContact_1;
                                                        if (matchValue_9[0] != null) {
                                                            if (matchValue_9[1] != null) {
                                                                pattern_matching_result_2 = 0;
                                                                dossierData_1 = matchValue_9[0];
                                                                dossierDataContact_1 = matchValue_9[1];
                                                            }
                                                            else {
                                                                pattern_matching_result_2 = 1;
                                                            }
                                                        }
                                                        else {
                                                            pattern_matching_result_2 = 1;
                                                        }
                                                        switch (pattern_matching_result_2) {
                                                            case 0: {
                                                                setCreatingDossier(true);
                                                                onCreateQuote(new CreateQuoteData2(dossierData_1, dossierDataContact_1, files))(patternInput_10[0])(patternInput_14[0])(patternInput_15[0])(patternInput_16[0])(patternInput_13[0])(() => {
                                                                    setCreatingDossier(false);
                                                                });
                                                                break;
                                                            }
                                                            case 1: {
                                                                break;
                                                            }
                                                        }
                                                        break;
                                                    }
                                                    default: {
                                                        iterate((data) => {
                                                            let homeVisitContact, homeVisitContact_1, matchValue_5, name_1, emails_1, customEmail, e_2, assignmentDocContact;
                                                            if (data.InvoicingParty.tag === 2) {
                                                            }
                                                            else if ((((homeVisitContact = data.Contact, (emailsError.Off(), (homeVisitContact == null) ? true : ((homeVisitContact_1 = homeVisitContact, (homeVisitContact_1.tag === 2) ? ((matchValue_5 = [data.ContactName, data.ContactEmail], (matchValue_5[0] != null) && ((name_1 = matchValue_5[0], true)))) : ((homeVisitContact_1.tag === 3) ? ((matchValue_5 = [data.ContactName, data.ContactEmail], (matchValue_5[0] != null) && ((name_1 = matchValue_5[0], true)))) : true)))))) && ((emails_1 = data.CertificateCustomEmails, (customEmail = data.CertificateEmailCustom, (emailsError.Off(), (((!data.CertificateEmailPartner) && (!customEmail)) && (!data.CertificateEmailClient)) ? ((emailsError.On(), false)) : (customEmail ? ((emails_1 == null) ? false : ((e_2 = emails_1, true))) : true)))))) && ((assignmentDocContact = data.AssignmentDocumentContact.Value, (assignmentDocContact.tag === 2) ? (data.AssignmentContactEmail != null) : ((assignmentDocContact.tag === 3) ? (data.AssignmentContactEmail != null) : ((assignmentDocContact.tag === 4) ? (data.AssignmentContactEmail != null) : true))))) {
                                                                patternInput_3[1](new CreateQuoteDataContact(data.AssignmentContactEmail, data.AssignmentDocumentContact.Value, data.CertificateCustomEmails, data.CertificateEmailClient, data.CertificateEmailCustom, data.CertificateEmailPartner, data.Contact, data.ContactName, data.ContactEmail, data.InvoicingParty, invoicePricing.State ? (new InvoicePricing(0)) : (new InvoicePricing(1))));
                                                                setStepsCompleted(updateStepCompletion(activeStep, true, stepsCompleted));
                                                                setActiveStep(activeStep + 1);
                                                            }
                                                        }, toArray_2(useFormValidator(assignmentDocumentContact.Validator, (r_3, x_9) => {
                                                            let assignVal;
                                                            const matchValue_4 = x_9.Value;
                                                            switch (matchValue_4.tag) {
                                                                case 2: {
                                                                    assignVal = useFormValidator(assignmentDocumentLegalRepEmail.Validator, (unitVar_8, x_10) => ({
                                                                        AssignmentDocumentContactEmail: x_10,
                                                                    }), useForm()).Validate();
                                                                    break;
                                                                }
                                                                case 3: {
                                                                    assignVal = useFormValidator(assignmentDocumentSyndicEmail.Validator, (unitVar_9, x_11) => ({
                                                                        AssignmentDocumentContactEmail: x_11,
                                                                    }), useForm()).Validate();
                                                                    break;
                                                                }
                                                                case 4: {
                                                                    assignVal = useFormValidator(assignmentDocumentOther.Validator, (unitVar_10, x_12) => ({
                                                                        AssignmentDocumentContactEmail: x_12,
                                                                    }), useForm()).Validate();
                                                                    break;
                                                                }
                                                                default: {
                                                                    assignVal = (void 0);
                                                                }
                                                            }
                                                            if (assignVal == null) {
                                                                return {
                                                                    AssignmentContactEmail: void 0,
                                                                    AssignmentDocumentContact: x_9,
                                                                    CertificateCustomEmails: r_3.CertificateCustomEmails,
                                                                    CertificateEmailClient: r_3.CertificateEmailClient,
                                                                    CertificateEmailCustom: r_3.CertificateEmailCustom,
                                                                    CertificateEmailPartner: r_3.CertificateEmailPartner,
                                                                    Contact: r_3.Contact,
                                                                    ContactEmail: r_3.ContactEmail,
                                                                    ContactName: r_3.ContactName,
                                                                    InvoicingParty: r_3.InvoicingParty,
                                                                };
                                                            }
                                                            else {
                                                                return {
                                                                    AssignmentContactEmail: assignVal.AssignmentDocumentContactEmail,
                                                                    AssignmentDocumentContact: x_9,
                                                                    CertificateCustomEmails: r_3.CertificateCustomEmails,
                                                                    CertificateEmailClient: r_3.CertificateEmailClient,
                                                                    CertificateEmailCustom: r_3.CertificateEmailCustom,
                                                                    CertificateEmailPartner: r_3.CertificateEmailPartner,
                                                                    Contact: r_3.Contact,
                                                                    ContactEmail: r_3.ContactEmail,
                                                                    ContactName: r_3.ContactName,
                                                                    InvoicingParty: r_3.InvoicingParty,
                                                                };
                                                            }
                                                        }, useFormValidator(invoice.Validator, (r_2, x_6) => {
                                                            if (foundCustomer) {
                                                                if (customer == null) {
                                                                    return {
                                                                        CertificateCustomEmails: r_2.CertificateCustomEmails,
                                                                        CertificateEmailClient: r_2.CertificateEmailClient,
                                                                        CertificateEmailCustom: r_2.CertificateEmailCustom,
                                                                        CertificateEmailPartner: r_2.CertificateEmailPartner,
                                                                        Contact: r_2.Contact,
                                                                        ContactEmail: r_2.ContactEmail,
                                                                        ContactName: r_2.ContactName,
                                                                        InvoicingParty: new DossierCustomer(2),
                                                                    };
                                                                }
                                                                else {
                                                                    return {
                                                                        CertificateCustomEmails: r_2.CertificateCustomEmails,
                                                                        CertificateEmailClient: r_2.CertificateEmailClient,
                                                                        CertificateEmailCustom: r_2.CertificateEmailCustom,
                                                                        CertificateEmailPartner: r_2.CertificateEmailPartner,
                                                                        Contact: r_2.Contact,
                                                                        ContactEmail: r_2.ContactEmail,
                                                                        ContactName: r_2.ContactName,
                                                                        InvoicingParty: new DossierCustomer(1, new DossierCustomerSelection(0, customer)),
                                                                    };
                                                                }
                                                            }
                                                            else {
                                                                const matchValue_1 = x_6.Value;
                                                                switch (matchValue_1.tag) {
                                                                    case 1: {
                                                                        const matchValue_2 = useFormValidator(invoiceCustomerPerson.Validator, (unitVar_6, x_7) => ({
                                                                            CustomerPersonData: x_7,
                                                                        }), useForm()).Validate();
                                                                        if (matchValue_2 == null) {
                                                                            return {
                                                                                CertificateCustomEmails: r_2.CertificateCustomEmails,
                                                                                CertificateEmailClient: r_2.CertificateEmailClient,
                                                                                CertificateEmailCustom: r_2.CertificateEmailCustom,
                                                                                CertificateEmailPartner: r_2.CertificateEmailPartner,
                                                                                Contact: r_2.Contact,
                                                                                ContactEmail: r_2.ContactEmail,
                                                                                ContactName: r_2.ContactName,
                                                                                InvoicingParty: new DossierCustomer(2),
                                                                            };
                                                                        }
                                                                        else {
                                                                            const c_2 = matchValue_2.CustomerPersonData;
                                                                            return {
                                                                                CertificateCustomEmails: r_2.CertificateCustomEmails,
                                                                                CertificateEmailClient: r_2.CertificateEmailClient,
                                                                                CertificateEmailCustom: r_2.CertificateEmailCustom,
                                                                                CertificateEmailPartner: r_2.CertificateEmailPartner,
                                                                                Contact: r_2.Contact,
                                                                                ContactEmail: r_2.ContactEmail,
                                                                                ContactName: r_2.ContactName,
                                                                                InvoicingParty: new DossierCustomer(1, new DossierCustomerSelection(1, new CustomerData2(0, new CustomerPersonData(c_2.LastName, c_2.FirstName, c_2.Address, c_2.Email, c_2.PhoneNumber, false)))),
                                                                            };
                                                                        }
                                                                    }
                                                                    case 2: {
                                                                        const matchValue_3 = useFormValidator(invoiceCustomerCompany.Validator, (unitVar_7, x_8) => ({
                                                                            CustomerCompanyData: x_8,
                                                                        }), useForm()).Validate();
                                                                        if (matchValue_3 == null) {
                                                                            return {
                                                                                CertificateCustomEmails: r_2.CertificateCustomEmails,
                                                                                CertificateEmailClient: r_2.CertificateEmailClient,
                                                                                CertificateEmailCustom: r_2.CertificateEmailCustom,
                                                                                CertificateEmailPartner: r_2.CertificateEmailPartner,
                                                                                Contact: r_2.Contact,
                                                                                ContactEmail: r_2.ContactEmail,
                                                                                ContactName: r_2.ContactName,
                                                                                InvoicingParty: new DossierCustomer(2),
                                                                            };
                                                                        }
                                                                        else {
                                                                            const c_4 = matchValue_3.CustomerCompanyData;
                                                                            return {
                                                                                CertificateCustomEmails: r_2.CertificateCustomEmails,
                                                                                CertificateEmailClient: r_2.CertificateEmailClient,
                                                                                CertificateEmailCustom: r_2.CertificateEmailCustom,
                                                                                CertificateEmailPartner: r_2.CertificateEmailPartner,
                                                                                Contact: r_2.Contact,
                                                                                ContactEmail: r_2.ContactEmail,
                                                                                ContactName: r_2.ContactName,
                                                                                InvoicingParty: new DossierCustomer(1, new DossierCustomerSelection(1, new CustomerData2(1, new CustomerCompanyData(c_4.CompanyName, c_4.CompanyType, c_4.Address, c_4.Email, c_4.PhoneNumber, c_4.VatNumber, false, c_4.IsVME, c_4.IsSocialHousingCompany, c_4.LastName, c_4.FirstName)))),
                                                                            };
                                                                        }
                                                                    }
                                                                    default: {
                                                                        if (customer == null) {
                                                                            return {
                                                                                CertificateCustomEmails: r_2.CertificateCustomEmails,
                                                                                CertificateEmailClient: r_2.CertificateEmailClient,
                                                                                CertificateEmailCustom: r_2.CertificateEmailCustom,
                                                                                CertificateEmailPartner: r_2.CertificateEmailPartner,
                                                                                Contact: r_2.Contact,
                                                                                ContactEmail: r_2.ContactEmail,
                                                                                ContactName: r_2.ContactName,
                                                                                InvoicingParty: new DossierCustomer(2),
                                                                            };
                                                                        }
                                                                        else {
                                                                            return {
                                                                                CertificateCustomEmails: r_2.CertificateCustomEmails,
                                                                                CertificateEmailClient: r_2.CertificateEmailClient,
                                                                                CertificateEmailCustom: r_2.CertificateEmailCustom,
                                                                                CertificateEmailPartner: r_2.CertificateEmailPartner,
                                                                                Contact: r_2.Contact,
                                                                                ContactEmail: r_2.ContactEmail,
                                                                                ContactName: r_2.ContactName,
                                                                                InvoicingParty: new DossierCustomer(0, customer),
                                                                            };
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }, useFormValidator(contact.Validator, (r_1, x_4) => {
                                                            const partnerEmail = isPartnerSelected.State && partnerToggle.State;
                                                            if (emailToggle.State) {
                                                                const emailsVal_1 = useFormValidator(emails.Validator, (unitVar_5, x_5) => ({
                                                                    CertificateCustomEmails: x_5,
                                                                }), useForm()).Validate();
                                                                if (emailsVal_1 == null) {
                                                                    return {
                                                                        CertificateCustomEmails: void 0,
                                                                        CertificateEmailClient: customerToggle.State,
                                                                        CertificateEmailCustom: emailToggle.State,
                                                                        CertificateEmailPartner: partnerEmail,
                                                                        Contact: r_1.Contact,
                                                                        ContactEmail: r_1.ContactEmail,
                                                                        ContactName: r_1.ContactName,
                                                                    };
                                                                }
                                                                else {
                                                                    return {
                                                                        CertificateCustomEmails: emailsVal_1.CertificateCustomEmails,
                                                                        CertificateEmailClient: customerToggle.State,
                                                                        CertificateEmailCustom: emailToggle.State,
                                                                        CertificateEmailPartner: partnerEmail,
                                                                        Contact: r_1.Contact,
                                                                        ContactEmail: r_1.ContactEmail,
                                                                        ContactName: r_1.ContactName,
                                                                    };
                                                                }
                                                            }
                                                            else {
                                                                return {
                                                                    CertificateCustomEmails: void 0,
                                                                    CertificateEmailClient: customerToggle.State,
                                                                    CertificateEmailCustom: emailToggle.State,
                                                                    CertificateEmailPartner: partnerEmail,
                                                                    Contact: r_1.Contact,
                                                                    ContactEmail: r_1.ContactEmail,
                                                                    ContactName: r_1.ContactName,
                                                                };
                                                            }
                                                        }, useFormValidator(contact.Validator, (unitVar_3, x) => {
                                                            if (x == null) {
                                                                return {
                                                                    Contact: void 0,
                                                                    ContactEmail: void 0,
                                                                    ContactName: void 0,
                                                                };
                                                            }
                                                            else {
                                                                const x_1 = x;
                                                                const matchValue = x_1.Value;
                                                                switch (matchValue.tag) {
                                                                    case 2:
                                                                    case 3: {
                                                                        const emailsVal = useFormValidator(contactEmail.Validator, (r, x_3) => ({
                                                                            ContactEmail: x_3,
                                                                            ContactName: r.ContactName,
                                                                        }), useFormValidator(contactName.Validator, (unitVar_4, x_2) => ({
                                                                            ContactName: x_2,
                                                                        }), useForm())).Validate();
                                                                        if (emailsVal == null) {
                                                                            return {
                                                                                Contact: x_1.Value,
                                                                                ContactEmail: void 0,
                                                                                ContactName: void 0,
                                                                            };
                                                                        }
                                                                        else {
                                                                            const e = emailsVal;
                                                                            return {
                                                                                Contact: x_1.Value,
                                                                                ContactEmail: e.ContactEmail,
                                                                                ContactName: e.ContactName,
                                                                            };
                                                                        }
                                                                    }
                                                                    default: {
                                                                        return {
                                                                            Contact: x_1.Value,
                                                                            ContactEmail: void 0,
                                                                            ContactName: void 0,
                                                                        };
                                                                    }
                                                                }
                                                            }
                                                        }, useForm())))).Validate()));
                                                    }
                                                }
                                            }])))))))));
                                        })))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_15))])]))));
                                    }));
                                })),
                            }))));
                        }));
                    }));
                }));
            }));
        }));
    })))), createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children_2)),
    }))];
    return react.createElement(react.Fragment, {}, ...xs_8);
}

